import localitoencantada from "@/assets/economicos/localitoencantada.jpeg";
import sushifrentemarco from "@/assets/economicos/sushifrentemarco.png";
import cocinasushi from "@/assets/economicos/cocinasushi.jpeg";
import freidora from "@/assets/economicos/freidora.jpeg";
import mesassushi from "@/assets/economicos/mesassushi.jpeg";
import refrisushi from "@/assets/economicos/refrisushi.jpeg";
import videolocalito from "@/assets/economicos/videolocalito.mp4";
import frente2laencantada from "@/assets/economicos/frente2laencantada.jpeg";
import sushienfrente2 from "@/assets/economicos/sushienfrente2.jpg";
import frentelaencantada from "@/assets/economicos/frentelaencantada.jpeg";
import bodegalastorres from "@/assets/economicos/bodegalastorres.jpeg";
import interior2bodega from "@/assets/economicos/interior2bodega.jpeg";
import interiorbodega from "@/assets/economicos/interiorbodega.jpeg";
import frente21demarzo from "@/assets/economicos/frente21demarzo.jpeg";
import interiorlocal1 from "@/assets/economicos/interiorlocal1.jpg";
import interiorminisplit from "@/assets/economicos/interiorminisplit.jpg";
import interior21demarzo from "@/assets/economicos/interior21demarzo.jpg";
import bano21demarzo from "@/assets/economicos/bano21demarzo.jpeg";
import frentelosangeles from "@/assets/economicos/frentelosangeles.jpeg";
import fachadaangeles from "@/assets/economicos/fachadaangeles.jpeg";
import cristalangeles from "@/assets/economicos/cristalangeles.jpeg";
import interior3 from "@/assets/economicos/interior3.jpeg";
import banoangeles from "@/assets/economicos/banoangeles.jpeg";
import interiorangeles2 from "@/assets/economicos/interiorangeles2.jpeg";
import frentetuna from "@/assets/economicos/frentetuna.jpeg";
import interiortuna2 from "@/assets/economicos/interiortuna2.jpeg";
import interiortuna from "@/assets/economicos/interiortuna.jpeg";
import banotuna from "@/assets/economicos/banotuna.jpeg";
import balcontuna from "@/assets/economicos/balcontuna.jpeg";
import frenteplazacastilla from "@/assets/economicos/frenteplazacastilla.jpeg";
import frentelocal8 from "@/assets/economicos/frentelocal8.jpeg";
import interiorlocal8castilla from "@/assets/economicos/interiorlocal8castilla.jpeg";
import interior8castilla from "@/assets/economicos/interior8castilla.jpeg";
import interior8castilla2 from "@/assets/economicos/interior8castilla2.jpeg";
import bano8castilla from "@/assets/economicos/bano8castilla.jpeg";
import locallastorres from "@/assets/economicos/locallastorres.jpeg";
import interiorlastorres from "@/assets/economicos/interiorlastorres.jpeg";
import banolocaltorres from "@/assets/economicos/banolocaltorres.jpeg";
import frentepolimedica from "@/assets/economicos/frentepolimedica.jpeg";
import entradapoli from "@/assets/economicos/entradapoli.jpg";
import  escaleraspoli from "@/assets/economicos/escaleraspoli.jpg";
import recepcionalta from "@/assets/economicos/recepcionalta.jpg";
import consultorio5 from "@/assets/economicos/consultorio5.jpg";
import polimedicavideo1 from "@/assets/economicos/polimedicavideo1.mp4";
import consultorio5a from "@/assets/economicos/consultorio5a.jpg";
import consultorio3a from "@/assets/economicos/consultorio3a.jpg";
import consultorio3 from "@/assets/economicos/consultorio3.jpg";
import videoconsultorio from "@/assets/economicos/videoconsultorio.mp4";
import frentecalzadamarco from "@/assets/economicos/frentecalzadamarco.png";
import local3frentecalzada from "@/assets/economicos/local3frentecalzada.jpeg";
import frentenuevocalzada from "@/assets/economicos/frentenuevocalzada.png";
import interiorcalzadal3 from "@/assets/economicos/interiorcalzadal3.jpeg";
import interior2local3 from "@/assets/economicos/interior2local3.jpeg";
import interior4 from "@/assets/economicos/interior4.jpeg";
import banolocal3 from "@/assets/economicos/banolocal3.jpeg";
import videocalzada3 from "@/assets/economicos/videocalzada3.mp4";
import frentegrandecalzada from "@/assets/economicos/frentegrandecalzada.jpeg";
import areagrande from "@/assets/economicos/areagrande.jpeg";
import interiorgrande from "@/assets/economicos/interiorgrande.jpeg";
import interior2grande from "@/assets/economicos/interior2grande.jpeg";
import cubiculo1calzada from "@/assets/economicos/cubiculo1calzada.jpeg";
import cubiculo2calzada from "@/assets/economicos/cubiculo2calzada.jpeg";
import cubiculo3 from "@/assets/economicos/cubiculo3.jpeg";
import banocubiculos from "@/assets/economicos/banocubiculos.jpeg";
import videogrande from "@/assets/economicos/videogrande.mp4";
import escalerasbuelna from "@/assets/economicos/escalerasbuelna.jpeg";
import buelnafrente from "@/assets/economicos/buelnafrente.jpeg";
import entradabuelna from "@/assets/economicos/entradabuelna.jpeg";
import cuartoentrada from "@/assets/economicos/cuartoentrada.jpeg";
import pasillobuelna from "@/assets/economicos/pasillobuelna.jpeg";
import cuartobuelna from "@/assets/economicos/cuartobuelna.jpeg";
import cuarto2 from "@/assets/economicos/cuarto2.jpeg";
import cuarto3 from "@/assets/economicos/cuarto3.jpeg";
import cuarto4 from "@/assets/economicos/cuarto4.jpeg";
import cuarto1 from "@/assets/economicos/cuarto1.jpeg";
import banosbuelna from "@/assets/economicos/banosbuelna.jpeg";
import entrada2buelna from "@/assets/economicos/entrada2buelna.jpeg";
import frentevallealto from "@/assets/economicos/frentevallealto.jpeg";
import frente2vallealto from "@/assets/economicos/frente2vallealto.jpeg";
import frente3vallealto from "@/assets/economicos/frente3vallealto.jpeg";
import frente4vallealto from "@/assets/economicos/frente4vallealto.jpeg";
import interiorvallealto from "@/assets/economicos/interiorvallealto.jpeg";
import fachadaportalegre from "@/assets/economicos/fachadaportalegre.jpeg";
import fachada2portalegre from "@/assets/economicos/fachada2portalegre.jpeg";
import plazaGammaPlano from "@/assets/economicos/plaza-gamma-plano.png";
import fachadachapuleJosefa from "@/assets/chapultepec-josefa/fachadachapule.jpeg";
import fachadafrenteChapuleJosefa from "@/assets/chapultepec-josefa/fachadafrente.jpeg";
import fachada2ChapuleJosefa from "@/assets/chapultepec-josefa/fachada2.jpeg";
import fachada3ChapuleJosefa from "@/assets/chapultepec-josefa/fachada3.jpeg";
import video2ChapuleJosefa from "@/assets/chapultepec-josefa/video2.mp4";
import videochapuleJosefa from "@/assets/chapultepec-josefa/videochapule.mp4";
import lapalma from "@/assets/economicos/lapalma.jpeg";
import lapalma2 from "@/assets/economicos/lapalma2.jpeg";
import lapalma5 from "@/assets/economicos/lapalma5.jpeg";
import lapalma6 from "@/assets/economicos/lapalma6.jpeg";
import frenteempaques from "@/assets/economicos/frenteempaques.jpeg";
import grandeempaques from "@/assets/economicos/grandeempaques.jpeg";
import grandeinterior from "@/assets/economicos/grandeinterior.jpeg";
import grandeinterior2 from "@/assets/economicos/grandeinterior2.jpeg";
import grandeinterior3 from "@/assets/economicos/grandeinterior3.jpeg";
import grandeinterior4 from "@/assets/economicos/grandeinterior4.jpeg";
import interiorlocal7 from "@/assets/economicos/interiorlocal7.jpg";
import interiorplantaalta from "@/assets/economicos/interiorplantaalta.jpg";
import frentecantabrianuevo from "@/assets/economicos/frentecantabrianuevo.png";
import empaquesfrentenuevo from "@/assets/economicos/empaquesfrentenuevo.png";
import cuarto5 from "@/assets/economicos/cuarto5.jpeg";
import tunafrente from "@/assets/economicos/tunafrente.png";
import frentecampina from "@/assets/economicos/frentecampina.jpeg";
import cocheracampina from "@/assets/economicos/cocheracampina.jpeg";
import pasillo2 from "@/assets/economicos/pasillo2.jpeg";
import salacampina from "@/assets/economicos/salacampina.jpeg";
import pasillointerior from "@/assets/economicos/pasillointerior.jpeg";
import cuartoconbano from "@/assets/economicos/cuartoconbano.jpeg";
import cuarto1campina from "@/assets/economicos/cuarto1campina.jpeg";
import cuarto2campina from "@/assets/economicos/cuarto2campina.jpeg";
import boiler from "@/assets/economicos/boiler.jpeg";
import patiocampina from "@/assets/economicos/patiocampina.jpeg";
import pasillocampina from "@/assets/economicos/pasillocampina.jpeg";
import escaleras from "@/assets/economicos/escaleras.jpeg";
import escaleras2 from "@/assets/economicos/escaleras2.jpeg";
import recibidor from "@/assets/economicos/recibidor.jpeg";
import recepcion2 from "@/assets/economicos/recepcion2.jpeg";
import salon1 from "@/assets/economicos/salon1.jpeg";
import cuartogrande from "@/assets/economicos/cuartogrande.jpeg";
import cuartochico from "@/assets/economicos/cuartochico.jpeg";
import banos from "@/assets/economicos/banos.jpeg";
import banos2 from "@/assets/economicos/banos2.jpeg";
import frenteculiacancito from "@/assets/economicos/frenteculiacancito.jpeg";
import esquinaculiacancito from "@/assets/economicos/esquinaculiacancito.jpeg";
import interior3culiacancito from "@/assets/economicos/interior3culiacancito.jpeg";
import interior2 from "@/assets/economicos/interior2.jpeg";
import frente1cln from "@/assets/economicos/frente1cln.png";
import frente2cln from "@/assets/economicos/frente2cln.png";
import interiorculiacancito from "@/assets/economicos/interiorculiacancito.jpeg";
import terrenoquintas from "@/assets/terrenoquintas/terrenoquintas.jpeg";
import fachadaquintas from "@/assets/terrenoquintas/fachadaquintas.jpeg";
import lateralterreno from "@/assets/terrenoquintas/lateralterreno.jpeg";
import atrasterrenoquintas from "@/assets/terrenoquintas/atrasterrenoquintas.jpeg";
import planosterrenoquintas from "@/assets/terrenoquintas/planosterrenoquintas.jpeg";
import terrenoanteior from "@/assets/terrenoquintas/terrenoanteior.jpeg";
import terrenonegocioanterior from "@/assets/terrenoquintas/terrenonegocioanterior.jpeg";
import frenteterrenocosterita from "@/assets/terreno-costerita/frenteterrenocosterita.jpeg";
import lateral1terrenocosterita from "@/assets/terreno-costerita/lateral1terrenocosterita.jpeg";
import terrenolateralcosterita from "@/assets/terreno-costerita/terrenolateralcosterita.jpeg";
import accesoaterrenocosterita from "@/assets/terreno-costerita/accesoaterrenocosterita.jpeg";
import acceso2terrenocosterita from "@/assets/terreno-costerita/acceso2terrenocosterita.jpeg";
import videoterrenocosterita from "@/assets/terreno-costerita/videoterrenocosterita.mp4";
import sanPedroCholulFrente from "@/assets/terreno-san-pedro-cholul/san-pedro-cholul-4.jpeg";
import sanPedroCholulAcceso from "@/assets/terreno-san-pedro-cholul/san-pedro-cholul-1.jpeg";
import sanPedroCholulInterior from "@/assets/terreno-san-pedro-cholul/san-pedro-cholul-2.jpeg";
import sanPedroCholulFondo from "@/assets/terreno-san-pedro-cholul/san-pedro-cholul-3.jpeg";
import sanPedroCholulCroquis from "@/assets/terreno-san-pedro-cholul/san-pedro-cholul-5.jpeg";
import sanPedroCholulUbicacion from "@/assets/terreno-san-pedro-cholul/san-pedro-cholul-6.jpeg";
import sitpachFrente from "@/assets/terreno-sitpach/sitpach-frente.jpeg";
import sitpachEsquina from "@/assets/terreno-sitpach/sitpach-esquina.jpeg";
import sitpachLateral from "@/assets/terreno-sitpach/sitpach-lateral.jpeg";
import sitpachConstruccion1 from "@/assets/terreno-sitpach/sitpach-doc-2.jpeg";
import sitpachConstruccion2 from "@/assets/terreno-sitpach/sitpach-doc-3.jpeg";
import sitpachTerrenoInterior1 from "@/assets/terreno-sitpach/sitpach-doc-4.jpeg";
import sitpachTerrenoInterior2 from "@/assets/terreno-sitpach/sitpach-doc-5.jpeg";
import sitpachUbicacionMapa from "@/assets/terreno-sitpach/sitpach-doc-6.jpeg";
import frentebodega5 from "@/assets/bodega-david/frentebodega5.png";
import bodega5luz from "@/assets/bodega-david/bodega5luz.png";
import interiorbodega5 from "@/assets/bodega-david/interiorbodega5.jpeg";
import interior2bodega5 from "@/assets/bodega-david/interior2bodega5.jpeg";
import pisobodega5 from "@/assets/bodega-david/pisobodega5.jpeg";
import rampabodega5 from "@/assets/bodega-david/rampabodega5.png";
import rampabodegaDavid from "@/assets/bodega-david/rampabodega.jpg";
import frentebodegarampa5 from "@/assets/bodega-david/frentebodegarampa5.png";
import alturabodegaDavid from "@/assets/bodega-david/alturabodega.jpg";
import videobodegaexterior from "@/assets/bodega-david/videobodegaexterior.mp4";
import bodega3Exterior from "@/assets/bodega3-costerita/bodega3exterior.png";
import bodega3Interior from "@/assets/bodega3-costerita/bodega3costeritainterior.jpeg";
import bodega3FotoOficina from "@/assets/bodega3-costerita/fotooficinabodega3.jpeg";
import bodega3Cuarto1 from "@/assets/bodega3-costerita/cuarto1bodega3.jpeg";
import bodega3Cuarto1Foto2 from "@/assets/bodega3-costerita/cuarto1foto2bodega.jpeg";
import bodega3Cuarto2 from "@/assets/bodega3-costerita/cuarto2bodega3.jpeg";
import bodega3Cuarto3 from "@/assets/bodega3-costerita/cuarto3bodega.jpeg";
import bodega3Bano from "@/assets/bodega3-costerita/banobodega3.jpeg";
import bodega3BanosInterior from "@/assets/bodega3-costerita/banosinterior3.jpeg";
import bodega3BanosInterior2 from "@/assets/bodega3-costerita/banosinterio2rbodega3.jpeg";
import bodega3BanoExterior from "@/assets/bodega3-costerita/fotobanofuerabodega3.jpeg";
import bodega3Piso from "@/assets/bodega3-costerita/pisobodega3.jpeg";
import bodega3Altura from "@/assets/bodega3-costerita/alturabodega.jpg";
import bodega3Oficina2 from "@/assets/bodega3-costerita/oficina2bodega3.jpeg";
import videoBodega3Oficina from "@/assets/bodega3-costerita/videobodega3oficina.mp4";
import fachadaBodega3Rios from "@/assets/bodega3rios/fachadabodega3rios.png";
import fachadaNaranjaBodega3Rios from "@/assets/bodega3rios/fachadanaranja.png";
import interiorBodega3Rios from "@/assets/bodega3rios/interiorbodega.jpeg";
import fotoBano3Rios from "@/assets/bodega3rios/fotobano3rios.png";
import interior1Bodega3Rios from "@/assets/bodega3rios/interior1bodega.png";
import interior2Bodega3Rios from "@/assets/bodega3rios/interiorbodega3rios.png";
import paredBodega3Rios from "@/assets/bodega3rios/pared3rios.jpeg";
import techoBodega3Rios from "@/assets/bodega3rios/techo3rios.jpeg";
import medioBanoBodega3Rios from "@/assets/bodega3rios/mediobanobodega3rios.jpeg";
import planoBodega3Rios from "@/assets/bodega3rios/plano3rios.jpeg";
import videoBodega3Rios from "@/assets/bodega3rios/videobodega3rios.mp4";
import frenteBodegaDiez from "@/assets/bodega-el-diez-b10/frentebodegadiez.jpeg";
import calleBodegaDiez from "@/assets/bodega-el-diez-b10/callelbodegadiez.jpeg";
import puertaBodegaDiez from "@/assets/bodega-el-diez-b10/puertabodegadiez.jpeg";
import interiorBodegaDiez from "@/assets/bodega-el-diez-b10/interiorbodegadiez.jpeg";
import pisoBodegaDiez from "@/assets/bodega-el-diez-b10/pisodiez2.jpeg";
import fachadaOficinaDiez from "@/assets/bodega-el-diez-b10/fachadaoficinadiez.jpeg";
import recepcionDiez from "@/assets/bodega-el-diez-b10/recepciondiez.jpeg";
import recepcionDiez2 from "@/assets/bodega-el-diez-b10/recepciondiez2.jpeg";
import privadoOficinaDiez from "@/assets/bodega-el-diez-b10/privadooficina.jpeg";
import banoBodegaDiez from "@/assets/bodega-el-diez-b10/banodiez.jpeg";
import frentenuevobodega from "@/assets/economicos/frentenuevobodega.jpeg";
import interior3bodega from "@/assets/economicos/interior3bodega.jpg";
import interior1bodega from "@/assets/economicos/interior1bodega.jpg";
import rampabodega from "@/assets/economicos/rampabodega.jpg";
import alturabodega from "@/assets/economicos/alturabodega.jpg";
import frente1aero from "@/assets/economicos/frente1aero.jpeg";
import interior2aero from "@/assets/economicos/interior2aero.jpeg";
import interioraero from "@/assets/economicos/interioraero.jpeg";
import frenteaeropuerto from "@/assets/economicos/frenteaeropuerto.jpeg";
import lateralaero from "@/assets/economicos/lateralaero.jpeg";
import videoaero from "@/assets/economicos/videoaero.mp4";
import frentebravo from "@/assets/economicos/frentebravo.jpeg";
import lateralbravo from "@/assets/economicos/lateralbravo.jpeg";
import interior3bravo from "@/assets/economicos/interior3bravo.jpeg";
import interior2bravo from "@/assets/economicos/interior2bravo.jpeg";
import bacurimifrente from "@/assets/economicos/bacurimifrente.jpeg";
import bacurimi from "@/assets/economicos/bacurimi.jpeg";
import bacurimi2 from "@/assets/economicos/bacurimi2.jpeg";
import bacurimi3 from "@/assets/economicos/bacurimi.jpeg";
import bacurimibano from "@/assets/economicos/bacurimibano.jpeg";
import banobravo from "@/assets/economicos/banobravo.jpeg";
import interior1bravo from "@/assets/economicos/interior1bravo.jpeg";
import interiorcochera from "@/assets/economicos/interiorcochera.jpeg";
import cocherachapule from "@/assets/economicos/cocherachapule.jpeg";
import casachapule from "@/assets/economicos/casachapule.jpeg";
import cocherachapule1 from "@/assets/economicos/cocherachapule1.jpeg";
import cocherachapule2 from "@/assets/economicos/cocherachapule2.jpeg";
import terrazachapule from "@/assets/economicos/terrazachapule.jpeg";
import patiochapule from "@/assets/economicos/patiochapule.jpeg";
import interior1chapule    from "@/assets/economicos/interior1chapule.jpeg";
import interior1 from "@/assets/economicos/interior1.jpeg";
import interiorchapule from "@/assets/economicos/interiorchapule.jpeg";
import pasillochapule from "@/assets/economicos/pasillochapule.jpeg";
import escalerachapule from "@/assets/economicos/escalerachapule.jpeg";
import cocinachapule from "@/assets/economicos/cocinachapule.jpeg";
import cuarto1chapule from "@/assets/economicos/cuarto1chapule.jpeg";
import cuarto2chapule from "@/assets/economicos/cuarto2chapule.jpeg";
import banochapule from "@/assets/economicos/banochapule.jpeg";
import banochapule2 from "@/assets/economicos/banochapule2.jpeg";
import frentelazaro2 from "@/assets/economicos/frentelazaro2.jpeg";
import frente2lazaro from "@/assets/economicos/frente2lazaro.jpeg";
import locallazaro from "@/assets/economicos/locallazaro.jpeg";
import interior1lazaro from "@/assets/economicos/interior1lazaro.jpeg";
import bannolazaro from "@/assets/economicos/bannolazaro.jpeg";
import frentelazaro1 from "@/assets/economicos/frentelazaro1.jpeg";
import puertalazaro from "@/assets/economicos/puertalazaro.jpeg";
import fachada2quintas from "@/assets/economicos/fachada2quintas.jpg";
import frentequintas from "@/assets/economicos/frentequintas.jpg";
import localquintas2 from "@/assets/economicos/localquintas2.jpg";
import fachadaquintas1 from "@/assets/economicos/fachadaquintas1.jpg";
import local1quintas from "@/assets/economicos/local1quintas.jpg";
import local1quintasbano from "@/assets/economicos/local1quintasbano.jpg";
import videonuevoquintas from "@/assets/economicos/videonuevoquintas.mp4";
import frentebravooficina from "@/assets/economicos/frentebravooficina.jpeg";
import fachadabravooficina from "@/assets/economicos/fachadabravooficina.jpeg";
import escalera2bravo from "@/assets/economicos/escalera2bravo.jpeg";
import recepcionbravo from "@/assets/economicos/recepcionbravo.jpeg";
import saladeestarbravo from "@/assets/economicos/saladeestarbravo.jpeg";
import puertabravo from "@/assets/economicos/puertabravo.jpeg";
import cuarto1bravo from "@/assets/economicos/cuarto1bravo.jpeg";
import cuartobravo from "@/assets/economicos/cuartobravo.jpeg";
import cuarto3bravo from "@/assets/economicos/cuarto3bravo.jpeg";
import bano1bravo from "@/assets/economicos/bano1bravo.jpeg";
import bano2bravojpeg from "@/assets/economicos/bano2bravojpeg.jpeg";
import balcon1bravo from "@/assets/economicos/balcon1bravo.jpeg";
import balcon2bravo from "@/assets/economicos/balcon2bravo.jpeg";
import fachadalocalitoblvd from "@/assets/economicos/fachadalocalitoblvd.jpeg";
import interiorlocalitoblvd from "@/assets/economicos/interiorlocalitoblvd.jpeg";
import interiororiginallocalitoblvd from "@/assets/economicos/interiororiginallocalitoblvd.jpeg";
import fachadaenmarcadacucas from "@/assets/economicos/fachadaenmarcadacucas.png";
import cucasinterior from "@/assets/economicos/cucasinterior.jpeg";
import frenteinteriorcucas from "@/assets/economicos/frenteinteriorcucas.jpeg";
import interior3cucas from "@/assets/economicos/interior3cucas.jpeg";
import balconcucas from "@/assets/economicos/balconcucas.jpeg";
import vistacucas from "@/assets/economicos/vistacucas.jpeg";


export const oportunidadesUnicas = [

{
  id: 101,
  title: "Local equipado para sushi y comida",
  subtitle: "Renta $6,500",
  image: sushifrentemarco,
    link: "/propiedad/1",
},

{
  id: 102,
  title: "Locales nuevos - se entregan listos",
    subtitle: "Renta $12,000",
    promo: "2 meses de renta gratis",
  image: frentevallealto,
  
  link: "/propiedad/18",
},

{
  id: 103,
  title: "Bodega dentro de la ciudad 120 m",
    subtitle: "Renta $8,000",
  image: bodegalastorres,
  link: "/propiedad/3",
},

{
  id: 104,
  title: "Terreno comercial en San Pedro Cholul",
  subtitle: "Renta pendiente",
  promo: "Recién agregado",
  image: sanPedroCholulFrente,
  link: "/propiedad/108",
},

{
  id: 105,
  title: "Terreno en esquina en Sitpach",
  subtitle: "Renta pendiente",
  promo: "Recién agregado",
  image: sitpachFrente,
  link: "/propiedad/109",
},
];

export const properties = [

  // ECONOMICOS
  {
  id: 1,

  title: "Local equipado para negocio de comida",
   
  price: 6000,

  address: "Colonia: 8 de Febrero",
  location: "Av:Las Torres casi Esquina: Pdte Manuel Echeverria",
  contrato: "1 año minimo",
  zona: "Comercial y Habitacional",
  servicios: "Luz independiente",
  flujo: "Sobre Blvd con flujo vehicular y peatonal",
  estado: "Equipado listo para iniciar",
  disponibilidad: "Entrega inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentación",
  asesorIA: {
    usosSugeridos: [
      "sushi",
      "comida",
      "comida para llevar",
      "restaurante",
      "postres",
      "cafeteria",
      "giro de comida",
    ],
    usosNoRecomendados: [
      "papeleria",
      "farmacia",
      "consultorio",
      "boutique",
      "tienda de ropa",
      "barberia",
      "estetica",
      "salon de belleza",
      "podologia",
    ],
    noApto: [
      "bodega",
      "bodega grande",
      "minisuper",
      "abarrotes",
      "expendio de cerveza",
      "gimnasio",
      "quimicos",
      "material peligroso",
      "taller mecanico",
    ],
    girosMismaPlaza: ["escuela de karate"],
    competenciaMismaPlaza: ["escuelade karate"],
    noDuplicarMismaPlaza: ["escuela de karate", "escuela de artes marciales"],
    competenciaCercana: [
      "sushi cercano",
      "restaurantes cercanos",
      "taquerias",
      "negocios de comida",
      "negocios de comida para llevar",
      "farmacias cercanas",
      "expendio de cerveza cercano",

    ],
    generadoresDemanda: [
      "boulevard con alto flujo vehicular",
      "avenida Las Torres",
      "camiones urbanos",
      "flujo vehicular la mayor parte del dia",
      "escuela de karate para niños en planta baja",
      "padres y alumnos de escuela de karate",
      "negocio de mariscos a dos locales",
      "zona habitacional",
      "Colonia 8 de Febrero",
    ],
    plantaBaja: {
      ideal: [],
      apto: [],
      pocoRecomendado: [],
      noApto: [],
    },
    plantaAlta: {
      ideal: [
        "sushi",
        "comida equipada",
        "comida para llevar",
        "restaurante",
        "cafeteria",
        "postres",
        "giro de comida",
      ],
      apto: [
        "cocina con consumo en sitio",
        "servicio con reservacion",
        "dark kitchen",
        "comida por pedido",
        "restaurantes"
      ],
      pocoRecomendado: [
        "papeleria",
        "farmacia",
        "consultorio",
        "boutique",
        "tienda de ropa",
        "barberia",
        "estetica",
        "salon de belleza",
        "podologia",
      ],
      noApto: [
        "bodega",
        "bodega grande",
        "minisuper",
        "abarrotes",
        "expendio de cerveza",
        "gimnasio",
        "quimicos",
        "material peligroso",
        "taller mecanico",
      ],
    },
    perfilCliente: {
      consumidorPrincipal: [
        "gente de paso sobre avenida Las Torres",
        "familias de la zona",
        "alumnos y padres de escuela de karate",
        "vecinos de Colonia 8 de Febrero",
        "personas de negocios cercanos",
        "personas que buscan comida para llevar",
      ],
      ticketZona: "medio bajo; sensible a precio",
      nivelSocioeconomicoEstimado: "medio bajo",
      confianza: "media",
      notas: [
        "estimado por conocimiento de zona y observacion de campo",
        "conviene oferta accesible, combos y precios de zona media baja",
        "el segundo piso requiere buena señalización para atraer clientes",
        "el giro debe considerar clientes de paso, vecinos y personas de la escuela de karate",
      ],
    },
    validacionCampo: {
      fecha: "2026-06-01",
      negociosActivosConfirmados: [
        "escuela de karate",
        "negocio de mariscos cercano",
        "expendio de cerveza cercano",
        "restaurantes cercanos",
        "taquerias cercanas",
        "farmacias cercanas",
      ],
      girosMismaPlazaConfirmados: ["escuela de karate"],
      flujoObservado: "vehicular constante la mayor parte del dia; pasan camiones y vehiculos privados; peatonal medio",
      horarioFuerte: ["comida", "tarde", "noche"],
      estacionamientoObservado: "2 cajones compartidos",
      fotosRecientes: true,
    },
    movilidad: {
      flujoVehicular: "alto",
      flujoPeatonal: "medio",
      estacionamiento: "2 cajones compartidos",
      transportePublico: "pasan camiones por la avenida",
      accesos: [
        "sobre boulevard",
        "sobre avenida Las Torres",
        "acceso por escaleras a segundo piso",
        "cerca de esquina",
      ],
      visibilidad: "buena desde boulevard, con balcón, anuncio luminoso y ubicación cercana a esquina",
    },
    entornoResidencial: {
      departamentosCercanos: "1 departamento para 2 personas arriba en la misma plaza",
      coloniasCercanas: ["Colonia 8 de Febrero"],
      observaciones: [
        "zona habitacional cercana",
        "cuidar ruido, olores fuertes y horarios por vivienda cercana",
        "zona media baja sensible a precio",
      ],
    },
    entornoConsumo: {
      anclasComerciales: [
        "escuela de karate para niños",
        "avenida Las Torres",
        "boulevard con alto flujo vehicular",
      ],
      negociosComplementarios: [
        "escuela de karate",
        "negocio de mariscos cercano",
        "expendio de cerveza cercano",
        "restaurantes cercanos",
        "taquerias cercanas",
        "farmacias cercanas",
      ],
      flujoPorHorarios: ["comida", "tarde", "noche"],
      consumoEsperado: "medio bajo; sensible a precio",
    },
    ventajas: [
      "local equipado para sushi o giro de comida",
      "cuenta con estufa, freidora, tarja, refrigerador y mesas",
      "puede adaptarse a comida para llevar, restaurante, postres o cafeteria",
      "sobre avenida Las Torres con alto flujo vehicular",
      "tiene balcón, anuncio luminoso y visibilidad cercana a esquina",
      "la escuela de karate en planta baja genera flujo recurrente de alumnos y padres",
    ],
    riesgos: [
      "esta en segundo piso",
      "validar flujo real para consumo en sitio",
      "validar permisos, gas, ventilacion y extraccion",
      "zona media baja: cuidar precios, combos y ticket promedio",
      "solo cuenta con 2 cajones compartidos entre los locales de la plaza",
    ],
    restriccionesOperativas: [
      "no bodegas",
      "no gimnasio",
      "no quimicos ni material peligroso",
      "no taller mecanico",
      "no minisuper, abarrotes o expendio de cerveza",
      "no ideal para giros de compra rapida o alto flujo en planta alta",
      "validar ruido y olores por vivienda cercana",
      "no duplicar escuela de karate o escuela de artes marciales",
      "no llenado de agua",
    ],
    validarAntes: [
      "permiso para comida",
      "gas",
      "horarios permitidos",
      "señalización visible desde avenida Las Torres",
      "uso de los 2 cajones compartidos",
      "que no se duplique giro existente en la plaza",
    ],
  },
 type: "economicos",
  ribbon: "LOCALES",
images: [
sushifrentemarco,
sushienfrente2,
  cocinasushi,
  freidora,
  mesassushi,
 refrisushi,
 ],

  // MAPA
  mapUrl:
    "https://maps.google.com/maps?q=24.758554, -107.380545&z=15&output=embed",

  // ­ƒôï TABLA PROFESIONAL
  details: {
     "baños": "1/2 baño",
    frente: "6",
    fondo: "10 ",
    medida: "60m²",
    nivel: "2do Piso",
    estacionamiento: "2 Cajones compartidos",

ventajasRapidas: [
  "Estufa,Freidora",
  "Tarja",
  "Refrigerador",
  "Minisplit",
  "Barra en cocina", 
  "Mesas y Sillas", 
  "Bandera publicitaria"],
},
},

{
  id: 2,
  title: "Local de 12m² en plaza",
  price: "2320 IVA incluido",
  address: "Fraccionamiento Stanza-Cantabria",
  location: "Esquina Blvd: Cantabria y Ampuero",
  contrato: "1 ano minimo",
  zona: "Comercial y Habitacional en crecimiento",
  servicios: "Luz y Agua independiente",
  flujo: "Excelente exposición y flujo constante",
  estado: "Se entregan listos para iniciar",
  disponibilidad: "Para entrega inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentación",
asesorIA: {
  usosSugeridos: [  "venta para llevar",
    "punto de entrega",
    "negocio de mostrador",
    "servicio express",
    "oficina pequeña",
    "papeleria",
    "cafe para llevar",
    "postres para llevar"],
  noApto: [],
  usosNoRecomendados: [],
  girosMismaPlaza: [],
  competenciaMismaPlaza: ["papeleria", "farmacia", "academia de baile", "minisuper con tortilleria", "cafeteria"],
  noDuplicarMismaPlaza: ["papeleria"],
  competenciaCercana: [],
  generadoresDemanda: ["zona residencial"],
  plantaBaja: {
    ideal: [],
    apto: [],
    pocoRecomendado: [],
    noApto: [],
  },
  plantaAlta: {
    ideal: [],
    apto: [],
    pocoRecomendado: [],
    noApto: [],
  },
  perfilCliente: {
    consumidorPrincipal: [
      "familias de la zona",
      "vecinos del fraccionamiento",
      "clientes de paso",
      "emprendedores de bajo presupuesto",
    ],
    ticketZona: "medio bajo; sensible a precio",
    nivelSocioeconomicoEstimado: "medio bajo",
    confianza: "media",
    notas: [
      "zona habitacional en crecimiento",
      "conviene giro de mostrador, pedidos o venta para llevar",
      "el espacio chico limita consumo en sitio e inventario grande",
    ],
  },
  ventajas: [ "ideal para pedidos, recoger y llevar",
    "funciona mejor como negocio de mostrador",
    "renta baja para validar un concepto"],
  riesgos: [  "no caben mesas para consumo en sitio",
    "validar permisos si requiere gas o extraccion",
    "espacio reducido para inventario grande"],
  clienteIdeal: ["emprendedor", "negocio local"],
  requisitosClave: ["estacionamiento 21 cajones compartidos"],
  validacionCampo: {
    fecha: "",
    negociosActivosConfirmados: [],
    girosMismaPlazaConfirmados: [],
    flujoObservado: "",
    horarioFuerte: [],
    estacionamientoObservado: "",
    fotosRecientes: false,
  },
  movilidad: {
    flujoVehicular: "",
    flujoPeatonal: "",
    estacionamiento: "",
    accesos: [],
    visibilidad: "",
  },
  entornoResidencial: {
    viviendasCercanas: "",
    departamentosCercanos: "",
    coloniasCercanas: [],
    observaciones: [],
  },
  entornoConsumo: {
    anclasComerciales: [],
    negociosComplementarios: [],
    flujoPorHorarios: [],
    consumoEsperado: "",
  },
  restriccionesOperativas: ["sin cocina pesada","no poner mesas afuera del local"],
  potencial: ["zona residencial en crecimiento", "junto a negocios ancla que ya generan flujo"],
  validarAntes: [ "extraccion o ventilacion",]
},
  
  type: "economicos",
   ribbon: "LOCALES",
   status: "En proceso de renta",
  images: [

    localitoencantada,
    frente2laencantada,
    frentelaencantada,
    {
      type: "video",
      src: videolocalito,
    }
  ],
  mapUrl: "https://maps.google.com/maps?q=24.822864, -107.458577&z=15&output=embed",
  details: {
   frente: "4",
    fondo: "3",
    medidas: "12m²",
    nivel: "Planta baja",
     estacionamiento: "21 cajones",
    ventajasRapidas: [
      "Plaza con afluencia segura",
      "Junto a Negocios ancla",
       "Zona en crecimiento",
    ],
     },
},

{
  id: 3,
  title: "Bodega con portón eléctrico sobre Boulevard",
  price: 8000,
  address: "Colonia 8 de Febrero",
  location: "Av:Las Torres casi Esquina: Pdte Manuel Echeverria",
  contrato: " 1 año minimo",
  zona: " Comercial y Habitacional",
  servicios: "Luz independiente",
  flujo: "Sobre Blvd con flujo vehicular y peatonal",
  estado: "Listo para iniciar",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentación",
  asesorIA: {
    usosSugeridos: ["bodega","paqueterias", "negocios de almacenamiento", "llanteras","Taller de motos","taller de bicicletas",
    "refaccionaria","taller de electrodomesticos","polarizado de autos"],
    usosNoRecomendados: ["llenado de agua","taller para autos","oficina",""],
    noApto: ["cocina pesada sin extracción","quimicos","escuela de karate"],
    girosMismaPlaza: ["escuela de karate",],
    competenciaMismaPlaza: ["escuela de karate",],
    noDuplicarMismaPlaza: ["escuela de karate",],
    competenciaCercana: ["negocio de mariscos","expendio de cerveza","taquerias","restaurantes","sushi",
      "farmcias"],
    generadoresDemanda: [
      "boulevard con flujo vehicular",
      "zona comercial y habitacional",
      "escuela de karate en la misma plaza",
      "escuelas cercanas",
      "ruta de camiones urbanos",
      "boulevares principales cercanos,"

    ],
    plantaBaja: {
      ideal: ["bodega","paqueterias chicas", "almacen productos sin quimicos", "taller de reparaciones electrodomesticas", "oficina con bodega"],
      apto: ["taller", "servicio tecnico", "proveedor", "atencion al publico con almacen"],
      pocoRecomendado: ["showroom grande", "gimnasio", "restaurantes"],
      noApto: ["quimicos", "material peligroso", "camioneta de 3.5 toneladas", "trailer"],
    },
    ventajas: [
      "porton electrico",
      "acceso directo desde boulevard",
      "permite almacen y atencion al publico",
      "cuenta con espacio frontal para estacionarse o descargar",
    ],
    riesgos: [
      "no entra camioneta de 3.5 toneladas",
      "validar altura exacta del porton",
      "distribucion en L",
    ],
    restriccionesOperativas: [
      "solo entra carro chico o camioneta chica",
      "no quimicos",
      "la plaza no acepta duplicar giros existentes",
      "maniobras limitadas para vehiculos grandes",
    ],
    plantaAlta: {
      ideal: [],
      apto: [],
      pocoRecomendado: [],
      noApto: [],
    },
    perfilCliente: {
      consumidorPrincipal: [
        "personas que van de paso",
        "padres y estudiantes de la escuela de karate",
        "trabajadores cercanos",
        "clientes que requieren recoger producto",
        "familas de la zona"
        
      ],
      ticketZona: "medio bajo; sensible a precio",
      nivelSocioeconomicoEstimado: "medio bajo",
      confianza: "media",
      notas: [
        "mejor para operacion practica que para showroom premium",
        "conviene negocio con entrega, almacen o servicio tecnico",
        "validar vehiculo y maniobras antes de cerrar trato",
      ],
    },
    validacionCampo: {
      fecha: "2026-05-29",
      negociosActivosConfirmados: [ "escuela de karate"],
      girosMismaPlazaConfirmados: ["escuela de karate"],
      flujoObservado: "alto",
      horarioFuerte: ["mañana","tarde","baja en la noche"],
      estacionamientoObservado: "1 cajon frontal para estacionarse o descargar",
      fotosRecientes: true,
    },
    movilidad: {
      flujoVehicular: "alto",
      flujoPeatonal: "medio",
      estacionamiento: "1 cajon frontal para estacionarse o descargar",
      accesos: ["acceso directo desde boulevard"],
      visibilidad: "buena desde boulevard",
    },
    entornoResidencial: {
      departamentosCercanos: "1 departamento para 2 personas arriba en la misma plaza",
      coloniasCercanas: ["Colonia 8 de Febrero", "Los huizaches","antonio toledo corro"],
      observaciones: ["cuidar giros con quimicos, olores fuertes o ruido excesivo"],
    },
    entornoConsumo: {
    anclasComerciales: ["six de tecate","oxxo","escuela de karate","deposito de mariscos","farmcias"],
      negociosComplementarios: ["restaurantes", "escuela de karate","avenidas principales","boulevard principal",
      "escuelas","farmacias","reffacionaria"],
      flujoPorHorarios: ["tarde", "noche"],
      consumoEsperado: "medio",
    },
    validarAntes: [
      "altura exacta del porton",
      "tipo de vehiculo que necesita entrar",
      "carga y descarga",
      "permisos para taller o almacenamiento",
    ],
  },
  type: "economicos",
   ribbon: "BODEGAS",
  images: [
    bodegalastorres,
    interior2bodega,
    interiorbodega,
 
  ],
  mapUrl: "https://maps.google.com/maps?q=24.758554, -107.380545&z=15&output=embed",
  details: {
    "baño": "1",
    frente: " m",
    fondo: " m",
    medidas: " 110m²",
    nivel: "Planta baja",

    estacionamiento: "Si",
       ventajasRapidas: [
      "Porton Electrico",
    "Bodega con fácil acceso dentro de la ciudad",
  "Conectividad rápida a vialidades principales"],
     },
},


{
  id: 33,
  title: "Oficina con minisplit, 3 divisiones, recepción y sala de espera",
  price: 6000,
  address: "Colonia Jorge Almada",
  location: "Av: Nicolas Bravo, entre Calle: Francisco Villa y Blvd: Francisco I. Madero",
  contrato: "1 año minimo",
  zona: "Zona comercial",
  servicios: "Luz independiente",
  flujo: "Alto flujo vehicular",
  estado: "Buen estado, se entrega pintado y limpio",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentacion",
  type: "economicos",
   ribbon: "OFICINA",
  images: [
    frentebravooficina,
    fachadabravooficina,
    escalera2bravo,
    recepcionbravo,
    saladeestarbravo,
    puertabravo,
    cuarto1bravo,
    cuartobravo,
    cuarto3bravo,
    bano1bravo,
    bano2bravojpeg,
    balcon1bravo,
    balcon2bravo,
  ],
  mapUrl: "https://maps.google.com/maps?q=24.803424546646884, -107.40271810719476&z=15&output=embed",
  details: {
    "baño": "3 baños",
    frente: "6.65",
    fondo: "14.35",
    medidas: "95.4m²",
    nivel: "Planta alta",

    estacionamiento: "No",
       ventajasRapidas: [
      "Excelente ubicacion centrica sobre vialidad de alto movimiento",
      "1 minisplit de 1 tonelada",
      "3 cuartos, area de recepcion y sala de estar",
      "Espacio de balcon",
    ],
     },
},


{
  id: 4,
  title: "3 Locales con minisplit junto a Farmacias Similares",
  price: 4500,
  address:"Colonia 21 de Marzo",
  location: "Calle:Corneta Francisco Ramirez",
  contrato: "1 año minimo",
  zona: "Comercial y habitacional",
  servicios: "Luz y Agua independiente",
  flujo: "“Ubicación con movimiento continuo”",
  estado: "Listos para iniciar",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentación",
  type: "economicos",
   ribbon: "LOCALES",
  images: [
    frente21demarzo,
    interiorlocal1,
    interiorminisplit,
    interior21demarzo,
    bano21demarzo,
  
  ],
  mapUrl: "https://maps.google.com/maps?q=24.778263, -107.360559&output=embed",
  details: {
    banos: 1,
    frente: "4",
    fondo: "6",
    medidas: "24m²",
    nivel: "",

    estacionamiento: "si",
    ventajasRapidas: ["Incluyen Minisplit 1 tonelada",
      "Ubicado junto a Farmacias Similares" ,
      "Excelente estado"],


  }
},

{
  id: 5,
  title: "Locales nuevos con internet y agua incluidos en la renta",
  price: 5500,
  location: "Colonia Los Ángeles",
  contrato: "1 año minimo",
  zona: "Zona comercial y habitacional",
  servicios: "Luz Independiente/ Agua incluida en la renta",
  flujo: "Paso constante de vehículos",
  estado: "Nuevos y se entregan listos para iniciar",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de desposito, fiadro, documentación",
  address: "Esquina Blvd:California con Calle:Alamitos",
  type: "economicos",
   ribbon: "LOCALES",
  images: [
   fachadaangeles,
   frentelosangeles,
   cristalangeles,
   interior3,
   banoangeles,
   interiorangeles2,
  
  ],
  mapUrl: "https://maps.google.com/maps?q=24.847283, -107.360104&z=15&output=embed",
  details: {
    banos: "Medio baño(1)",
    frente: "3.6 ",
    fondo: "5.72",
    medidas: "20.5m²",
    nivel: "Planta baja",

    estacionamiento: "3 cajones  ",
    ventajasRapidas: ["Incluye servicios de agua e internet",
        "Ubicación en esquina",
      "Locales nuevos"],

  }
},

{
  id: 35,
  title: "3 locales nuevos, se entregan listos para que inicies",
  price: 4000,
  location: "Av: Alvaro Obregon",
  contrato: "1 año minimo",
  zona: "Zona comercial y habitacional",
  servicios: "Luz independiente",
  flujo: "Alto flujo vehicular todo el dia",
  estado: "Nuevos, listos para iniciar",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentacion",
  address: "Colonia Las Cucas",
  type: "economicos",
  ribbon: "LOCALES",
  images: [
    fachadaenmarcadacucas,
    cucasinterior,
    frenteinteriorcucas,
    interior3cucas,
    balconcucas,
    vistacucas,
  ],
  mapUrl: "https://maps.google.com/maps?q=24.842588741410232, -107.39445839869032&z=15&output=embed",
  details: {
    banos: "1",
    frente: "4",
    fondo: "7.5",
    medidas: "30m²",
    nivel: "Planta alta",
    estacionamiento: "si",
    ventajasRapidas: [
      "Ubicados en avenida: Álvaro Obregon",
      "Se entregan con divisón y baño",
      "En zona comercial de alto movimiento desde temprano.",
    ],
  }
},

{
  id: 6,
  title: "Local con minisplit incluido planta alta",
  link: "/propiedad/6",
  price: 6500,
  address:"Fraccionamiento La Conquista",
  location: "Blvd:La Tuna",
  contrato: "1 año minimo",
  zona: "Comercial y habitacional",
  servicios: "Luz independiente-Agua e internet incluidos según giro y consumo",
  flujo: "Constante durante todo el día",
  estado: "Excelente estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentación",
  type: "economicos",
    ribbon: "LOCALES",
  images: [
    tunafrente,
frentetuna,
interiortuna2,
interiortuna,
banotuna,
balcontuna,
  
  ],
  mapUrl: "https://maps.google.com/maps?q=24.822287, -107.437603&output=embed",
  details: {
    banos: "Medio baño(1)",
    frente: "5.7",
    fondo: "5.9",
    medidas: "33m²",
    nivel: "Planta alta",

    estacionamiento: "Disponible sobre la calle de enfrente",
    ventajasRapidas: ["Incluye Minisplit 1 tonelada",
     "Agua e internet incluidos según giro y consumo",
    "Sobre blvd  con alta afluencia vehicular"],

  }
},

{
  id: 7,
  title: "Local Rodeado de Privadas y Áreas Residenciales",
   link: "/propiedad/7",
  price: 8000,
  address:"Fraccionamiento Stanza Castilla",
  location: "Blvd:Nueva España",
  contrato: "1 año minimo",
  zona: "Comercial y Residencial",
  servicios: "Luz y Agua",
  flujo: "Zona transitada",
  estado: "Usado buen estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiadro y documentación",
  type: "economicos",
   ribbon: "LOCALES",
  images: [
    frenteplazacastilla,
frentelocal8,
interiorlocal8castilla,
interior8castilla,
interior8castilla2,
bano8castilla,

 ],
  mapUrl: "https://maps.google.com/maps?q=24.823329, -107.446691&output=embed",
  details: {

    "baños": "Medio baño(1)",
    frente: "4.5",
    fondo: "8",
    medidas: "36 m²",
    estacionamiento: "12 cajones",
    nivel: "Planta baja",
    ventajasRapidas: ["Ubicación ideal cerca de privadas residenciales",
      "Facil acceso"
    ]
  }
},

{
  id: 8,
  title: "Listo para emprender con barra y tarja",
   link: "/propiedad/8",
  price: 4000,
  address:"Colonia 8 de Febrero",
  location: "Av:Las Torres",
  contrato: "1 año minimo",
  zona: "Comercial y habitacional",
  servicios: "Luz independiente",
  flujo: "Flujo constante durante el día",
  estado: "Usado en buen estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "mes de renta, mes de deposito, fiadro, documentación",
  type: "economicos",
   ribbon: "LOCALES",
  images: [
locallastorres,
interiorlastorres,
banolocaltorres,

 ],
  mapUrl: "https://maps.google.com/maps?q=24.758554, -107.380545&z=15&output=embed",
  details: {
    banos: "Medio baño (1)",
    frente: "3",
    fondo: "6",
    medidas: "18m²",
    nivel: "Planta baja",

    estacionamiento: "Espacio al frente del local",
    ventajasRapidas: ["Tarja",
"Barra recibidor", 
"Lavamanos",
"abanico",
"Área al aire libre"],


  }
},

{
  id: 9,
  title: "Consultorio/Minisplit,Wifi y Mantenimiento incluido",
   link: "/propiedad/9",
  price: 6500 ,
   address:"Colonia: Culiacán Centro",
  location: "Calle:Mariano Escobedo",
  contrato: "1 año minimo",
  zona: "Comercial y habitacional",
  servicios: "Se incluyen en la renta",
  flujo: "Excelente ubicación en zona céntrica",
  estado: "Usado en buen estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito,fiador y documentación",
  type: "economicos",
   ribbon: "CONSULTORIOS",
  images: [
frentepolimedica,
entradapoli,
escaleraspoli,
recepcionalta,
consultorio3a,
consultorio3,

   {
      type: "video",
      src: videoconsultorio,
    }
  ],
  mapUrl: "https://maps.google.com/maps?q=24.806907, -107.390961&output=embed",
  details: {
    banos: "Disponibles",
    frente: "2.90",
    fondo: "3.40",
    medidas: "9.86m²",
    nivel: "Planta alta",

    estacionamiento: "Si",
    ventajasRapidas: ["Minisplit 1 tonelada",
"Lavamanos",
"Recepcionista",
"Wifi y luz del edificio",
"Espacio dentro de Polimedica",
"Recepción y sala de espera",
"Incluye mantenimiento"],
 },
},


{
  id: 10,
  title: "Consultorio/Recepcionista,Wifi y Mantenimiento incluido",
   link: "/propiedad/10",
  price: 8000,
  location: "Calle:Mariano Escobedo",
  contrato: "1 año minimo",
  zona: "Comercial y habitacional",
  servicios: "Se Incluyen en la renta",
  flujo: "Zona centrica con facil acceso",
  estado: "Buen estado",
  disponibilidad: "Inmediato",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de depostio, fiador,documentación",
  address: "Colonia: Culiacan Centro, a media cuadra de Aquiles Serdan",
  type: "economicos",
   ribbon: "CONSULTORIOS",
  images: [
entradapoli,
frentepolimedica,
escaleraspoli,
recepcionalta,
consultorio5,
consultorio5a, 

{
      type: "video",
      src: polimedicavideo1,
    }
  ],
  mapUrl: "https://maps.google.com/maps?q=24.806907, -107.390961&output=embed",
  details: {
    banos: 1,
    frente: "3.35",
    fondo: "5.50",
    medidas: "18.4m²",
    nivel: "Planta alta",

    estacionamiento: "Si",
    ventajasRapidas: ["Minisplit 1 tonelada",
"Lavamanos",
"Recepcionistaa y sala de esoera",
"Wifi y luz del edificio",
"Espacio dentro de Polimedica",
"Incluye mantenimiento"],

  }
},

{
  id: 11,
  title: "Ubicación estratégica sobre boulevard con alta visibilidad",
   link: "/propiedad/11",
  price: 4500,
  location: "Calzada Colegio Heroico Militar",
  contrato: "1 año minimo",
  zona: "Comercial",
  servicios: "Luz independiente",
  flujo: "Blvd con alto flujo vehicular",
  estado: "Usado, buen estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador, documentación",
  address: "Colonia: Emiliano Zapata",
  type: "economicos",
   ribbon: "LOCALES",
  images: [
frentecalzadamarco,
local3frentecalzada,
interiorcalzadal3,
interior2local3,
interior4,
banolocal3,

   {
      type: "video",
      src: videocalzada3,
    }

 
  ],
  mapUrl: "https://maps.google.com/maps?q=24.78655176840576, -107.370973423442&output=embed",
  details: {
    banos: 1,
    frente: "3.65",
    fondo: "8.37",
    medidas: "30.55m²",
    nivel: "Planta alta",

    estacionamiento: "4 cajones ",
    ventajasRapidas: ["Dividio en 3 áreas funcionales",
   "Ubicación estratégica con flujo constante"],
  }
},

{
  id: 12,
  title: "Sobre boulevard de alto flujo vehicular",
   link: "/propiedad/12",
  price: 8000,
  location: "Calzada Colegio Heroico Militar",
  contrato: "1 año minimo",
  zona: "Comercial",
  servicios: "Luz independiente",
  flujo: "Alto fujo vehicular",
  estado: "Usado en buen estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiadro y documentación",
  address: "Colonia: Emiliano Zapata",
  type: "economicos",
   ribbon: "LOCALES",
  images: [
frentenuevocalzada,
frentegrandecalzada,
areagrande,
interiorgrande,
interior2grande,
cubiculo1calzada,
cubiculo2calzada,
cubiculo3,
banocubiculos,

  {
      type: "video",
      src: videogrande,
    }
  ],
  mapUrl: "https://maps.google.com/maps?q=24.78655176840576, -107.370973423442&output=embed",
  details: {
    banos: 1,
    frente: "4.8",
    fondo: "14.22",
    medidas: "68.2m²",
    nivel: "Planta alta",

    estacionamiento: "4 cajones",
    ventajasRapidas: ["Cuenta con 5 áreas independientes",
"Ubicado en boulevard principal con excelente conectividad"],
  }
},

{
  id: 13,
  title: "Local accesible sobre Blvd Francisco I Madero",
  link: "/propiedad/13",
  price: 2500,
  address: "Colonia: Culiacán Centro",
  location: "Blvd. Francisco I. Madero, casi esquina Ignacio Aldama",
  contrato: "Minimo 1 ano",
  zona: "Comercial",
  servicios: "Luz independiente",
  flujo: "Flujo vehicular durante todo el dia",
  estado: "Usado, en buen estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "Si",
  requisitosRenta: "Mes de renta, mes de deposito, fiadro, documentación",
  type: "economicos",
  ribbon: "LOCALES",
  images: [
    fachadalocalitoblvd,
    {
      src: interiorlocalitoblvd,
      label: "Se entrega limpio y despejado",
    },
    {
      src: interiororiginallocalitoblvd,
      label: "Estado actual del local",
    },
  ],

  mapUrl: "https://www.google.com/maps?q=24.805066, -107.388626&output=embed",
  details: {
    banos: "1",
    frente: "3",
    fondo: "4",
    medidas: "12m²",
    nivel: "Planta baja",
    estacionamiento: "no",
    ventajasRapidas: [
      "Renta super accesible",
      "Sobre boulevard con movimiento todo el dia",
     "Frente a Subdelegación del IMSS",
     "Zona activa desde las primeras horas del día",
    ],
  }
},

{
  id: 26,
  title: "400m en Esquina sobre avenida principal frente a aeropuerto",
   link: "/propiedad/26",
  price: 20000,
  address: "Colonia: Bachigualato",
  location: "Calzada Aeropuerto esquina Calle:Luis Gonzales Urbina",
  contrato: "Minimo 1 año",
  zona: "Comercial y Habitacional",
  servicios: "Luz y agua independiente",
  flujo: "Constante todo el dia-Vehicular",
  estado: "Buen estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, me de deposito, fiador, documentación",
  type: "local",
    lat: 24.775026,
  lng: -107.465356,
  
  images: [
    frente1aero,
    frenteaeropuerto,
    interior2aero,
    interioraero,
    lateralaero,
    
   {
      type: "video",
      src: videoaero,
    }
 
  ],
mapUrl: "https://www.google.com/maps?q=24.775026,-107.465356&z=18&output=embed",
  details: {
    banos: 1,
    frente: "10m",
    fondo: "40 m",
    medidas: "400 m²",
    nivel: "Planta baja",
    estacionamiento: "10 cajones",
    ventajasRapidas: ["Entrada por boulevard y calle — acceso cómodo desde ambos lados",
   "Amplios espacios para adaptar a las necesidades de tu negocio",
  "Gran visibilidad en esquina para atraer más clientes"],

  
  }
},

{
  id: 27,
  title: "175 M² en Esquina-Av.Bravo-2 Minisplit ",
   link: "/propiedad/27",
  price: 16000,
    address: "Colonia: Los Pinos",
  location: "Av:Nicolás Bravo esquina Rio Coatzacoalacos",
  contrato: "Minimo 1 año",
  zona: "Comercial y Habitacional",
  servicios: "Luz y Agua independiente",
  flujo: "Vehicular todo el dia",
  estado: "Buen estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentación",
  
  type: "local",
  images: [
  frentebravo,
  lateralbravo,
  interior3bravo,
  interior2bravo,
  banobravo,
  interior1bravo,
  interiorcochera,
    
  
  ],
mapUrl: "https://www.google.com/maps?q=24.791047, -107.400692&z=18&output=embed",
  details: {
    banos: 1,
    frente: "10m",
    fondo: "17 m",
    medidas: "175 m²",
    nivel: "Planta baja y Planta alta",

    estacionamiento: "1",
    ventajasRapidas: ["• Incluye 2 minisplit en planta baja",
   "Ubicación en esquina sobre avenida de alto flujo vehicular",
  "Parte alta con espacios tipo oficina y bodega grande"],

  }
},

{
  id: 28,
  title: "250m² con amplio estacionamiento ",
   link: "/propiedad/28",
  price: 15000,
  address: "Colonia:Bacurimi",
  location: "Sobre Calle del Dren, atras de Oxxo",
  contrato: "Minimo 1 año",
  zona: "Comercial",
  servicios: "Luz y agua independiente",
  flujo: "Vehicular",
  estado: "Buen estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador, documentación",
  
  type: "local",
  images: [
  bacurimifrente,
  bacurimi,
  bacurimi2,
  bacurimi3,
  bacurimibano,
    
  
  ],
mapUrl: "https://www.google.com/maps?q=24.81234226498657, -107.45489970271268&z=18&output=embed",
  details: {
    banos: 1,
    frente: "14m",
    fondo: "18 m",
    medidas: "252 m²",
    nivel: "Pllanta baja",

    estacionamiento: "10 cajones",
    ventajasRapidas: ["Excelente ubicación junto a OXXO",
    "A un costado de Blvd con alto flujo vehicular",
  "Ideal para oficinas, restaurante, gimnasio, por sus amplios esapcios",
"Abanicos instalados"],

  }
},


{
  id: 34,
  title: "Locales nuevos sobre Blvd Conquistadores",
  link: "/propiedad/34",
  price: 10000,
  address: "Colonia: Portalegre",
  location: "Blvd Conquistadores esquina con calle Enrique Borgoña",
  contrato: "1 año minimo",
  zona: "Comercial y Residencial",
  servicios: "Luz y Agua independiente",
  flujo: "Vehicular todo el dia",
  estado: "Nuevos, se entregan listos para iniciar",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador,documentación",
  type: "local",
  status: "2 locales en proceso de renta",
  images: [
    fachadaportalegre,
    fachada2portalegre,
    plazaGammaPlano,
  ],
  mapUrl: "https://www.google.com/maps?q=24.824130,-107.439100&z=18&output=embed",
  details: {
    banos: 1,
    frente: "5.00",
    fondo: "7.70",
    medidas: "38.50m2",
    nivel: "Planta baja a pie de calle",
    estacionamiento: "8 cajones",
    ventajasRapidas: ["En esquina",
"Incluyen división, baño, instalación electrica y piso",
"Excelente ubicación sobre blvd Conqusitadores",
"Facil acceso para tus clientes"
],
  }
},

{
  id: 36,
  title: "Local comercial en esquina en Chapultepec",
  link: "/propiedad/36",
  price: 10000,
  address: "Colonia: Chapultepec",
  location: "Josefa Ortiz de Dominguez esquina con calle Vicente Suarez",
  contrato: "Minimo 1 año",
  zona: "Comercial y Residencial",
  servicios: "Luz y Agua independiente",
  flujo: "Vehicular la mayor parte del dia",
  estado: "Nuevos",
  disponibilidad: "En etapa final de construccion",
  tiempoGracia: "Si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentacion",
  type: "local",
  images: [
    fachadachapuleJosefa,
    fachadafrenteChapuleJosefa,
    fachada2ChapuleJosefa,
    fachada3ChapuleJosefa,
    {
      type: "video",
      src: video2ChapuleJosefa,
    },
    {
      type: "video",
      src: videochapuleJosefa,
    },
  ],
  mapUrl: "https://www.google.com/maps?q=24.82094090870074,-107.39073407517706&z=18&output=embed",
  lat: 24.82094090870074,
  lng: -107.39073407517706,
  details: {
    banos: "1",
    frente: "",
    fondo: "",
    medidas: "",
    nivel: "Planta baja",
    estacionamiento: "Si",
    ventajasRapidas: [
      "En esquina",
      "Excelente zona para cualquier giro",
      "Con piso y baño", 
      "Instalacion electrica y divisiones",
    ],
  }
},

/* =========================
   ­ƒƒú OFICINAS Y CONSULTORIOS
========================= */

{
  id: 17,
  title: "Equipado con 8 minisplit y 8 divisiones en tablaroca",
    link: "/propiedad/17",
  price: 15500,
address: "Colonia:Las Quintas, frente a parque los animales",
  location: "Calle:Buelna",
  contrato: "Minimo 1 año",
  zona: "Comercial y habitacional",
  servicios: "Luz y agua independiente",
  flujo: "Vehicular constante todo el día",
  estado: "Muy buen estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de desposito, fiador, documentación",
  type: "oficina",
  images: [   
  buelnafrente,
  escalerasbuelna,
  entradabuelna,
  cuartoentrada,
  pasillobuelna,
  cuartobuelna,
  cuarto5,
  cuarto2,
  cuarto3,
  cuarto4,
  cuarto1,
  banosbuelna,
  entrada2buelna


  ] ,


  mapUrl: "https://maps.google.com/maps?q=24.81186326162924, -107.38245815635304&output=embed",
  details: {
    banos: 1,
    frente: "4 m",
    fondo: "7 m",
    medidas: "120m²",
    nivel: "Planta alta",

    estacionamiento: "si",
    ventajasRapidas: [],

    ventajas: 
    `• Ubicación céntrica con excelente accesibilidad y flujo constante.
• 8 cubículos equipados con minisplit, ideales para atención profesional.
• 3 baños funcionales para comodidad de usuarios y personal.
• Espacio listo para operar de inmediato, sin necesidad de inversión.
• Ideal para consultorios, clínica, escuela de capacitación u oficinas corporativas.
• Cuenta con 1 cajón de estacionamiento propio y amplio espacio al frente para clientes.`
  }
},

{
  id: 18,
  title: "Nuevos se entregan listos para iniciar tu negocio",
  promoRibbon: "2 meses de renta gratis",
    link: "/propiedad/18",
  price: 12000,
address: "Colonia:Valle Alto",
  location: "Blvd:Sendero del Valle",
  contrato: "Minimo 1 año",
  zona: "Comercial y Habitacional",
  servicios: "Luz y Agua independiente",
  flujo: "",
  estado: "Nuevos",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentación",
  type: "local",
  images: [   
frentevallealto,
  frente2vallealto,
frente3vallealto,
frente4vallealto,
interiorvallealto

] ,
 mapUrl: "https://www.google.com/maps?q=24.800856, -107.465042&z=18&output=embed",
  details: {
    banos: 1,
    frente: "3.75 m",
    fondo: "11.85m",
    medidas: "44m²",
    nivel: "Planta baja",

    estacionamiento: "si",
    ventajasRapidas: [],

    ventajas: 
    `•Se entregan con piso terminado.
• Medio baño incluido.
• Cristal con puerta de acceso.
• Instalación eléctrica lista.
• División interior incluida.
• Excelente ubicación en zona residencial y comercial sobre boulevard.
• Locales nuevos.
• 4 cajones de estacionamiento.
• Gran visibilidad desde la avenida principal.
• Superficie total de 177 m², se puede rentar todo o en partes.
`
  }
},

{
  id: 19,
  title: "Cerca del IMSS en zona estrategica",
    link: "/propiedad/19",
  price: 3500,
address: "La Palma,Navolato",
  location: "Avenida:México",
  contrato: "",
  zona: "",
  servicios: "",
  flujo: "",
  estado: "",
  disponibilidad: "",
  tiempoGracia: "si",
  requisitosRenta: "",
  type: "economicos",
   ribbon: "LOCALES",
  images: [   
lapalma,
lapalma2,
lapalma5,
lapalma6

  ] ,


  mapUrl: "https://maps.google.com/maps?q=24.819873, -107.655833&output=embed",
  details: {
    banos: 1,
    frente: "3.75 m",
    fondo: "11.85m",
    medidas: "44m²",
    nivel: "",

    estacionamiento: "si",
    ventajasRapidas: [],

    ventajas: 
    `• 4 locales disponibles en excelente ubicación.
• Situados cerca de IMSS, Farmacias Similares y gasolinera.
• Sobre avenida principal de alto flujo vehicular.
• Zona con gran visibilidad y constante movimiento comercial.
• Ideal para negocios que buscan exposición y fácil acceso.
`
  }
},

{
  id: 20,
  title: "Adaptalo a tus necesidades",
    link: "/propiedad/20",
  price: 16000,
location: "Colonia: Barrancos",
contrato: "",
zona: "",
servicios: "",
flujo: "",
estado: "",
disponibilidad: "",
tiempoGracia: "si",
requisitosRenta: "",
  address: "Avenida:Empaques",
  type: "local",
  images: [ 
    empaquesfrentenuevo,  
frenteempaques,
grandeempaques,
grandeinterior,
grandeinterior2,
grandeinterior3,
grandeinterior4

  ] ,


mapUrl: "https://www.google.com/maps?q=24.760236, -107.436036&z=18&output=embed",
  details: {
    banos: 1,
    frente: "3.75 m",
    fondo: "11.85m",
    medidas: "83m²",
    nivel: "",

    estacionamiento: "si",
    ventajasRapidas: [],

    ventajas: 
    `• Local nuevo en planta baja, adaptalo a tus necesidades.
• Cuenta con estacionamiento propio para mayor comodidad.
• Ubicado en zona residencial y comercial con excelente entorno.
• Acompañado de 12 departamentos en planta alta que generan flujo constante de clientes potenciales.
• Alta visibilidad y exposición para tu negocio.
• Ideal para giro comercial o de servicios.
`
  }
},

{
  id: 21,
  title: "Listos para Operar en Plaza con Alta Afluencia",
    link: "/propiedad/21",
  price: 10000,
address: "Colonia: Stanza Cantabria",
  location: "Blvd:Cantabria Esquina con Calle:Ampuero",
  contrato: "Minimo 1 año",
  zona: "Residencial y comercial",
  servicios: "Luz y agua independiente",
  flujo: "Vehicular",
  estado: "Nuevos",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentación",
  type: "local",
  images: [ 
    frentecantabrianuevo,  
frente2laencantada,
interiorlocal7,
interiorplantaalta,
frentelaencantada
] ,
   mapUrl: "https://www.google.com/maps?q=24.822864, -107.458577&z=18&output=embed",
  details: {
    banos: 1,
    frente: "4.95 m",
    fondo: "9.10m",
    medidas: "45m²",
    nivel: "Planta alta",

    estacionamiento: "21 cajones",
    ventajasRapidas: [
      "Se entregan con división, piso, medio baño e instalación eléctrica",
      "Con afluencia segura todos los días",
      "Zona consolidada y en crecimiento",
    ],

    ventajas: 
    `• Se entregan con división, piso, medio baño e instalación eléctrica.
• Con afluencia segura todos los días.
• Zona consolidada y en crecimiento.
• 21 cajones de estacionamiento disponibles.
• Gran visibilidad desde la avenida.
• Planta alta, 4 espacios disponibles.
`
  }
},

{
  id: 30,
  title: "66 m² con Drive-Thru Sobre Avenida Principal | Terreno de 167 m² ",
   link: "/propiedad/30",
  price: 14500,
  address: "Colonia:Lazaro Cardenas",
  location: "Av 21 de Marzo Esquina con Pdte.Eulalio Gutierrez",
  contrato: "Minimo 1 año",
  servicios: "Agua y luz independiente",
  flujo: "Alto flujo vehicular sobre avenida",
  estado: "Listo para mostrarse",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, deposito y documentacion",
  zona: "Comercial y habitacional",

  
  type: "local",
  images: [
frente2lazaro,
frentelazaro2,
locallazaro,
interior1lazaro,
bannolazaro,
frentelazaro1,
puertalazaro,
    
  
  ],
mapUrl: "https://www.google.com/maps?q=24.774489645074958, -107.37732659399418&z=18&output=embed",
  details: {
    "baños": 1,
    frente: "12m",
    fondo: "5.5m",
    medidas: "66m²",
   

    estacionamiento: "2 cajones",
    ventajasRapidas: [
      "Servicio al auto (Drive Thrue)",
 "Ubicación en esquina estratégica",
"Sobre boulevard de alto flujo vehicular",
"Ruta de camiones cercano",
"Gran exposición para tu negocio"],

  }
},


{
  id: 31,
  title: "Ubicación Ideal Para Oficina o Negocio",
    link: "/propiedad/31",
  price: "7900 + IVA",
address: "Colonia:Las Quintas",
  location: "Av:Venustiano Carranza, casi Esquina con Buelna",
  contrato: "",
  zona: "",
  servicios: "",
  flujo: "",
  estado: "",
  disponibilidad: "",
  tiempoGracia: "si",
  requisitosRenta: "",
  type: "economicos",
     ribbon: "LOCALES",
  images: [ 
    fachada2quintas,  
localquintas2,
frentequintas,


] ,
 mapUrl: "https://www.google.com/maps?q=24.811675, -107.384169&z=18&output=embed",
  details: {
    banos: 1,
    frente: "5.15 m",
    fondo: "8.30m",
    medidas: "42.7m²",
    nivel: "",

    estacionamiento: "si",
    ventajasRapidas: [],

    ventajas: 
    `• Ubicado en zona céntrica sobre Av. Carranza
• Excelente visibilidad y alto flujo vehicular
• Fácil acceso desde diferentes puntos de la ciudad
• Piso nuevo listo para operar
• Cajones de estacionamiento al frente
• Instalación preparada para minisplit
• Ideal para oficina, consultorio o negocio comercial
• Zona rodeada de comercios y servicios
• Espacio con excelente iluminación natural
• Listo para adaptarse a diferentes giros comerciales
`
  }
},

{
  id: 32,
  title: "Espacio perfecto para tu negocio",
    link: "/propiedad/32",
  price: "6900 + IVA", 
address: "Colonia:Las Quintas",
  location: "Av:Venustiano Carranza, casi Esquina con Buelna",
  contrato: "",
  zona: "",
  servicios: "",
  flujo: "",
  estado: "",
  disponibilidad: "",
  tiempoGracia: "si",
  requisitosRenta: "",
  type: "economicos",
   ribbon: "LOCALES",
  images: [ 
    fachadaquintas1,  
local1quintas,
local1quintasbano,
frentequintas,

 {
      type: "video",
      src: videonuevoquintas,
    }
] ,
 mapUrl: "https://www.google.com/maps?q=24.811675, -107.384169&z=18&output=embed",
  details: {
    banos: 1,
    frente: "5 m",
    fondo: "7m",
    medidas: "35m²",
    nivel: "",

    estacionamiento: "si",
    ventajasRapidas: [],

    ventajas: 
    `• Ubicado en zona céntrica sobre Av. Carranza
• Excelente visibilidad y alto flujo vehicular
• Fácil acceso desde diferentes puntos de la ciudad
• Piso nuevo listo para operar
• Cajones de estacionamiento al frente
• Instalación preparada para minisplit
• Ideal para oficina, consultorio o negocio comercial
• Zona rodeada de comercios y servicios
• Espacio con excelente iluminación natural
• Listo para adaptarse a diferentes giros comerciales
`
  }
},

/* =========================
   CASAS PARA NEGOCIO
========================= */

{
  id: 22,
  title: "Casa de Una Planta Ideal para Negocio | 250 m² de Terreno",
   link: "/propiedad/22",
  price: 15500,
 address: "Colonia: La campiña",
  location: "Calle: De la Toronja",
  contrato: "Minimo 1 año",
  zona: "Habitacional",
  servicios: "Luz y agua independiente",
  flujo: "Vehicular",
  estado: "Buen estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentación",
  type: "casa",
  images: [
    frentecampina,
    cocheracampina,
    pasillo2,
    salacampina,
    pasillointerior,
    cuartoconbano,
    cuarto1campina,
    cuarto2campina,
    boiler,
    patiocampina,
    pasillocampina
],
  mapUrl: "https://maps.google.com/maps?q=24.81359195587096, -107.36166531032362&output=embed",
  details: {
    banos: 2,
    frente: "10m",
    fondo: "25 m",
    medidas: "250 m²",
    nivel: "",

    estacionamiento: "Sí",
    ventajasRapidas: [],

    ventajas: 
`• Ideal para agencia de marketing,clínicas u oficina administrativa.
• Cochera con espacio para 2 autos.
• Entrada independiente hacia el patio.
• 3 habitaciones con clóset (principal con baño completo).
• Cocina integral equipada.
• Totalmente refrigerada.
• Propiedad de una sola planta.
• Ubicada en zona tranquila.`
  }
},

{
  id: 23,
  title: "Amplios salones + espacios extra: todo lo que necesitas en una sola propiedad",
   link: "/propiedad/23",
  price: 13000,
  address: "Colonia: Nuevo Culiacan",
  location: "Calle:Lucernilla, casi esquina con Av:Guadalupe Victoria",
  contrato: "Minimo 1 año",
  zona: "Habitacional",
  servicios: "Luz y agua compartida",
  flujo: "Vehicular",
  estado: "Buen estado",
  disponibilidad: "",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentación",
  type: "casa",
  images: [
    cuartogrande,
    salon1,
  recibidor,
    recepcion2,
escaleras2,
  escaleras,
    cuartochico,
    banos,
    banos2


  ],
  mapUrl: "https://maps.google.com/maps?q=24.784183197233837, -107.40778300429932&output=embed",
  details: {
    banos: 3,
    frente: "8 m",
    fondo: "17 m",
    medidas: "250 m²",
    nivel: "",

    estacionamiento: "Sí",
    ventajasRapidas: [],

    ventajas: `Espacio amplio
Ideal para clínica
Zona residencial`
  }
},

{
  id: 29,
  title: "Esquina con Terraza, Jardín y Cochera para 6 Autos | 480 m²",
   link: "/propiedad/29",
  price: 23000,
 address: "Colonia: Chapultepec",
  location: "Juan Escutia esquina con Reynando Gonzales",
  contrato: "Minimo 1 año",
  zona: "Habitacional",
  servicios: "Luz y agua independiente",
  flujo: "",
  estado: "Buen estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador, documentación",
  type: "casa",
  images: [
 cocherachapule,
 casachapule,
 cocherachapule1,
 cocherachapule2,
 terrazachapule,
 patiochapule,
 pasillochapule,
 interior1chapule,
 interior1,
 interiorchapule,
 escalerachapule,
 cocinachapule,
 cuarto1chapule,
 cuarto2chapule,
 banochapule,
 banochapule2,
],
 mapUrl: "https://www.google.com/maps?q=24.821387, -107.391184&z=18&output=embed",
  details: {
    banos: 3,
    frente: "20m",
    fondo: "24 m",
    medidas: "480 m²",
    nivel: "2 plantas",

    estacionamiento: "Sí",
    ventajasRapidas: [],

    ventajas: 
`• Propiedad en esquina 
• Cochera con capacidad para hasta 6 autos
• 4 habitaciones amplias, incluyendo 1 en planta baja
• Áreas verdes y espacios abiertos con jardín
• 239 m² de construcción sobre terreno de 480 m²
• Ideal para consultorios, clínicas u oficinas corporativas
• Excelente opción para escuela, academia o centro de capacitación
• Espacios funcionales para agencia de marketing o coworking
• Fácil acceso y comodidad para clientes y personal
• Gran potencial comercial y profesional
• Distribución versátil para distintos tipos de negocio
• Excelente iluminación y ventilación natural`
  }
},

/* =========================
   ­ƒîÄ TERRENOS
========================= */

{
  id: 37,
  title: "Terreno comercial en Malecon Viejo",
  link: "/propiedad/37",
  price: 85000,
  address: "Las Quintas",
  location: "Paseo Ninos Heroes (Malecon viejo), esquina con Av. Xicotencatl",
  contrato: "Minimo 1 Año",
  zona: "Comercial y Habitacional",
  servicios: "Luz y Agua independiente",
  flujo: "Alto flujo vehicular todo el dia",
  estado: "Terreno listo para proyecto comercial",
  disponibilidad: "Inmediata",
  tiempoGracia: "Si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentación",
  type: "terreno",
  images: [
    terrenoquintas,
    fachadaquintas,
    lateralterreno,
    atrasterrenoquintas,
    { src: planosterrenoquintas, label: "Plano del terreno" },
    { src: terrenoanteior, label: "Negocio anterior" },
    { src: terrenonegocioanterior, label: "Negocio anterior" },
  ],
  lat: 24.818352,
  lng: -107.379997,
  mapUrl: "https://maps.google.com/maps?q=24.818352, -107.379997&z=15&output=embed",
  details: {
    frente: "48.50",
    fondo: "24.16",
    medidas: "1,171.76m2",
    nivel: "A pie de calle",
    estacionamiento: "Si",
   
    ventajasRapidas: [
      "Excelente exposición para marcas, Franquicias y negocios de alto impacto",
      "Amplio frente con gran visibilidad comercial",
      "Ubicación en esquina sobre una de las avenidas más reconocidas de Culiacán",
    ],

  }
},

{
  id: 24,
  title: "Terreno en esquina Culiacancito",
    link: "/propiedad/24",
  price: 10000,
  address: "Culiacancito",
  location: "Alvaro Obregon, Esquina Calle: Socorro Zazueta",
  contrato: "Minimo 1 año",
  zona: "Comercial y Habitacional",
  servicios: "Luz y Agua independiente",
  flujo: "Vehicular todo el dia",
  estado: "Buen estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiadro y documentación",
  type: "terreno",
  images: [
    frente1cln,
    frente2cln,
  esquinaculiacancito,
  interior3culiacancito,
  interiorculiacancito,
  interior2

  ],
  mapUrl: "https://maps.google.com/maps?q=24.825688, -107.531674&z=15&output=embed",
  details: {
    banos: 2,
    frente: "13 ",
    fondo: "28.87 ",
    medidas: "375.31m²",
    nivel: "Sobre carretera",

    estacionamiento: "Sí",
    ventajasRapidas: ["Sobre carretera ala entrada de Culiacancito",
      "Acceso por dos frentes: ideal para maniobras y flujo de clientes",
    "Terreno completamente bardeado, listo para operar o desarrollar"],


  }
},

{
  id: 106,
  title: "Terreno en esquina La Costerita",
  link: "/propiedad/106",
  price: "Precio por confirmar",
  address: "La Costerita",
  location: "Carretera:La Costerita,Libramiento Benito Juarez",
  contrato: "Minimo 1 año",
  zona: "Corredor comercial e industrial de La Costerita",
  servicios: "Luz y agua independiente",
  flujo: "Alto flujo vehicular y de transporte de carga, con presencia de bodegas, empresas y área residencial",
  estado: "Buen estado",
  disponibilidad: "Inmediato",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentación",
  asesorIA: {
    usosSugeridos: [],
    usosNoRecomendados: [],
    noApto: [],
    girosMismaPlaza: [],
    competenciaMismaPlaza: [],
    noDuplicarMismaPlaza: [],
    competenciaCercana: [],
    generadoresDemanda: [],
    plantaBaja: {
      ideal: [],
      apto: [],
      pocoRecomendado: [],
      noApto: [],
    },
    plantaAlta: {
      ideal: [],
      apto: [],
      pocoRecomendado: [],
      noApto: [],
    },
    perfilCliente: {
      consumidorPrincipal: [],
      ticketZona: "",
      nivelSocioeconomicoEstimado: "",
      confianza: "",
      notas: [],
    },
    validacionCampo: {
      fecha: "",
      negociosActivosConfirmados: [],
      girosMismaPlazaConfirmados: [],
      flujoObservado: "",
      horarioFuerte: [],
      estacionamientoObservado: "",
      fotosRecientes: false,
    },
    movilidad: {
      flujoVehicular: "",
      flujoPeatonal: "",
      estacionamiento: "",
      accesos: [],
      visibilidad: "",
    },
    entornoResidencial: {
      viviendasCercanas: "",
      departamentosCercanos: "",
      coloniasCercanas: [],
      observaciones: [],
    },
    entornoConsumo: {
      anclasComerciales: [],
      negociosComplementarios: [],
      flujoPorHorarios: [],
      consumoEsperado: "",
    },
    ventajas: [],
    riesgos: [],
    restriccionesOperativas: [],
    validarAntes: [],
  },
  type: "terreno",
  images: [
    frenteterrenocosterita,
    lateral1terrenocosterita,
    terrenolateralcosterita,
    accesoaterrenocosterita,
    acceso2terrenocosterita,
    {
      type: "video",
      src: videoterrenocosterita,
    },
  ],
  mapUrl: "https://maps.google.com/maps?q=24.740334, -107.433518&z=15&output=embed",
  details: {
    medidas: "",
    nivel: "",
    estacionamiento: "",
    ventajasRapidas: [
      "Terreno en esquina",
      "Frente a privada residencial en proceso",
      "Acceso rapido desde la carretera",
      "Doble frente",
    ],
    ventajas: "",
  },
},

{
  id: 108,
  title: "Terreno comercial en San Pedro Cholul",
  link: "/propiedad/108",
  price: "Renta pendiente",
  address: "San Pedro Cholul, Mérida, Yucatán",
  location: "Calle 22 Interconexión número 571",
  ciudad: "Mérida",
  state: "Yucatán",
  contrato: "Minimo 1 año",
  zona: "Residencial y comercial en crecimiento",
  servicios: "Luz y agua",
  flujo: "A pie de carretera, a 2 min del Periférico y Carretera Mérida-Motul",
  estado: "Terreno aplanado",
  disponibilidad: "Inmediata",
  status: "Recién agregado",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador, documentación",
  contacto: {
    nombre: "Dane Loría D",
    telefono: "2223915038",
    correo: "danelialoria@gmail.com",
  },
  asesorIA: {
    usosSugeridos: [
      "Comercio y servicios en general",
      "Mini bodegas, almacenamiento o centros de distribución ligeros",
      "Car wash o lubricentro",
      "Franquicias de bajo impacto",
      "Servicios de atención al público",
    ],
    usosNoRecomendados: [
      "Gasera o estación de gas LP",
    ],
    noApto: [
      "Gasera o estación de gas LP por restricción del ayuntamiento",
    ],
    girosMismaPlaza: [],
    competenciaMismaPlaza: [],
    noDuplicarMismaPlaza: [],
    competenciaCercana: [
      "Super Aki",
      "Farmacias Similares",
      "Tintorería",
      "Domino's Pizza",
      "Tacos",
      "Tim Hortons",
      "Wendy's",
      "DQ",
      "Gimnasio",
      "Canchas de pádel",
    ],
    generadoresDemanda: [
      "Gran San Pedro Cholul",
      "Privada Anturio",
      "Centro comercial a menos de 1 km",
      "Fraccionamientos residenciales cercanos",
      "Cercanía con Periférico y Carretera Mérida-Motul",
    ],
    plantaBaja: {
      ideal: [],
      apto: [],
      pocoRecomendado: [],
      noApto: [],
    },
    plantaAlta: {
      ideal: [],
      apto: [],
      pocoRecomendado: [],
      noApto: [],
    },
    perfilCliente: {
      consumidorPrincipal: [
        "Residentes de fraccionamientos cercanos",
        "Clientes de paso por flujo vehicular",
        "Usuarios que buscan servicios de conveniencia, salud, comida rápida y cuidado personal",
      ],
      ticketZona: "",
      nivelSocioeconomicoEstimado: "",
      confianza: "",
      notas: [
        "Zona con crecimiento residencial acelerado y demanda alta de servicios.",
      ],
    },
    validacionCampo: {
      fecha: "",
      negociosActivosConfirmados: [],
      girosMismaPlazaConfirmados: [],
      flujoObservado: "",
      horarioFuerte: [],
      estacionamientoObservado: "",
      fotosRecientes: true,
    },
    movilidad: {
      flujoVehicular: "Alto flujo vehicular por proximidad al Periférico y Carretera Mérida-Motul",
      flujoPeatonal: "",
      estacionamiento: "",
      accesos: [
        "A pie de carretera",
        "Rápido acceso desde Periférico",
        "Rápido acceso desde Carretera Mérida-Motul",
      ],
      visibilidad: "Buena visibilidad para negocios de atención al público",
    },
    entornoResidencial: {
      viviendasCercanas: "Fraccionamientos residenciales cercanos",
      departamentosCercanos: "",
      coloniasCercanas: [
        "Gran San Pedro Cholul",
        "Privada Anturio",
      ],
      observaciones: [
        "A un lado hay canchas de pádel.",
        "A menos de 1 km hay centro comercial con supermercado, farmacias, comida rápida, tintorería y gimnasio.",
      ],
    },
    entornoConsumo: {
      anclasComerciales: [
        "Super Aki",
        "Farmacias Similares",
        "Tim Hortons",
        "Wendy's",
        "DQ",
      ],
      negociosComplementarios: [
        "Tintorería",
        "Restaurantes de comida rápida",
        "Tacos",
        "Gimnasio",
        "Canchas de pádel",
      ],
      flujoPorHorarios: [],
      consumoEsperado: "Servicios de conveniencia, salud, comida rápida y cuidado personal",
    },
    ventajas: [
      "Zona con crecimiento residencial acelerado.",
      "Alto flujo vehicular por proximidad al Periférico y Carretera Mérida-Motul.",
      "Demanda alta de servicios de conveniencia, salud, comida rápida y cuidado personal.",
      "Competencia equilibrada sin saturación.",
    ],
    riesgos: [
      "Validar giro específico contra Cédula Urbana antes de cerrar trato.",
    ],
    restriccionesOperativas: [
      "Gasera o estación de gas LP prohibido por el ayuntamiento.",
    ],
    validarAntes: [
      "Precio de renta",
      "Contrato mínimo",
      "Requisitos de renta",
      "Estacionamiento o maniobras requeridas por el giro",
    ],
  },
  type: "terreno",
  images: [
    sanPedroCholulFrente,
    sanPedroCholulAcceso,
    sanPedroCholulInterior,
    sanPedroCholulFondo,
    { src: sanPedroCholulCroquis, label: "Croquis del terreno" },
    { src: sanPedroCholulUbicacion, label: "Ubicación marcada" },
  ],
  lat: 21.029690,
  lng: -89.559774,
  mapUrl: "https://maps.google.com/maps?q=21.029690, -89.559774&z=15&output=embed",
  details: {
    frente: "19.8 m",
    fondo: "50 m",
    medidas: "912 m²",
    nivel: "A pie de carretera",
    estacionamiento: "",
    ventajasRapidas: [
      "A 2 min del Periférico y Carretera Mérida-Motul",
      "Terreno aplanado con servicios disponibles",
      "Zona con crecimiento residencial acelerado",
      "Centro comercial y servicios a menos de 1 km",
    ],
    ventajas:
      `• Terreno aplanado con rápido acceso.
• A pie de carretera.
• Servicios disponibles: luz, agua e internet.
• A un lado hay canchas de pádel.
• A menos de 1 km hay centro comercial con Super Aki, Farmacias Similares, tintorería, comida rápida, gimnasio y otros servicios.
• Cerca de fraccionamientos residenciales como Gran San Pedro Cholul y Privada Anturio.
• Usos permitidos según Cédula Urbana: comercio y servicios en general, mini bodegas, almacenamiento, centros de distribución ligeros, servicios automotrices, franquicias de bajo impacto y servicios de atención al público.
• Restricción: gasera o estación de gas LP prohibido por el ayuntamiento.`,
  },
},

{
  id: 109,
  title: "Terreno en esquina en Sitpach",
  link: "/propiedad/109",
  price: "Renta pendiente",
  address: "Sitpach, Mérida, Yucatán",
  location: "Calle 12 número 52G",
  ciudad: "Mérida",
  state: "Yucatán",
  contrato: "Minimo 1 año",
  zona: "Comunidad y Habitacional",
  servicios: "Luz y agua",
  flujo: "Paso vehicular para acceder a nuevos desarrollos habitacionales de vivienda media alta",
  estado: "Buen estado",
  disponibilidad: "Inmediata",
  status: "Recién agregado",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador, documentación",
  restricciones: "No tiene restricciones",
  contacto: {
    nombre: "Dane Loría",
    telefono: "2223915038",
    correo: "danelialoria@gmail.com",
  },
  asesorIA: {
    usosSugeridos: [
      "Tienda de abarrotes",
      "Farmacia con consultorio médico",
      "Laboratorio de análisis clínicos",
      "Ferretería",
      "Servicios",
      "Restaurante",
    ],
    usosNoRecomendados: [],
    noApto: [],
    girosMismaPlaza: [],
    competenciaMismaPlaza: [],
    noDuplicarMismaPlaza: [],
    competenciaCercana: [],
    generadoresDemanda: [
      "Casas habitación de lugareños",
      "Comunidad pequeña al centro de la comisaría",
      "Paso vehicular hacia nuevos desarrollos habitacionales",
      "Vivienda media alta cercana",
    ],
    plantaBaja: {
      ideal: [],
      apto: [],
      pocoRecomendado: [],
      noApto: [],
    },
    plantaAlta: {
      ideal: [],
      apto: [],
      pocoRecomendado: [],
      noApto: [],
    },
    perfilCliente: {
      consumidorPrincipal: [
        "Habitantes de Sitpach",
        "Personas que transitan hacia desarrollos habitacionales",
        "Residentes de vivienda media alta cercana",
      ],
      ticketZona: "",
      nivelSocioeconomicoEstimado: "Medio a medio alto en nuevos desarrollos cercanos",
      confianza: "",
      notas: [
        "Zona de comunidad pequeña con paso vehicular hacia nuevos desarrollos.",
      ],
    },
    validacionCampo: {
      fecha: "",
      negociosActivosConfirmados: [],
      girosMismaPlazaConfirmados: [],
      flujoObservado: "",
      horarioFuerte: [],
      estacionamientoObservado: "",
      fotosRecientes: false,
    },
    movilidad: {
      flujoVehicular: "Paso vehicular hacia nuevos desarrollos habitacionales",
      flujoPeatonal: "",
      estacionamiento: "",
      accesos: [
        "Esquina a pie de calle",
        "Calle 13 perpendicular a la carretera Chichí Suárez o calle 14",
      ],
      visibilidad: "Ubicación en esquina",
    },
    entornoResidencial: {
      viviendasCercanas: "Casas habitación de lugareños y nuevos desarrollos habitacionales",
      departamentosCercanos: "",
      coloniasCercanas: [
        "Sitpach",
      ],
      observaciones: [
        "Centro de la comisaría con comunidad pequeña.",
        "Paso vehicular hacia vivienda media alta.",
      ],
    },
    entornoConsumo: {
      anclasComerciales: [],
      negociosComplementarios: [],
      flujoPorHorarios: [],
      consumoEsperado: "Abarrotes, farmacia, salud, ferretería, servicios y restaurantes",
    },
    ventajas: [
      "Ubicación en esquina.",
      "Terreno amplio de 1,771 m².",
      "Construcción pequeña de aproximadamente 100 m² con baño.",
      "Fácil y rápido acceso por conexión con carretera Chichí Suárez o calle 14.",
      "Sin restricciones reportadas.",
    ],
    riesgos: [
      "Validar precio de renta, contrato y requisitos antes de publicar condiciones finales.",
    ],
    restriccionesOperativas: [
      "No tiene restricciones reportadas.",
    ],
    validarAntes: [
      "Precio de renta",
      "Contrato mínimo",
      "Tiempo de gracia",
      "Requisitos de renta",
      "Fotos finales del terreno",
    ],
  },
  type: "terreno",
  images: [
    sitpachFrente,
    sitpachEsquina,
    sitpachLateral,
    sitpachTerrenoInterior1,
    sitpachTerrenoInterior2,
    sitpachConstruccion1,
    sitpachConstruccion2,
    { src: sitpachUbicacionMapa, label: "Croquis de ubicación" },
  ],
  mapUrl: "https://maps.google.com/maps?q=calle%2012%20numero%2052G%20Sitpach%20Merida%20Yucatan&z=15&output=embed",
  details: {
    banos: 1,
    frente: "34.7 m",
    fondo: "51 m",
    medidas: "1,771 m²",
    construccion: "Aproximadamente 100 m²",
    nivel: "Esquina a pie de calle",
    estacionamiento: "",
    ventajasRapidas: [
      "Ubicación en esquina",
      "Área total de 1,771 m²",
      "Construcción pequeña con baño",
      "Servicios disponibles: agua, luz e internet",
    ],
    ventajas:
      `• Terreno en esquina a pie de calle.
• Área total de 1,771 m².
• Cuenta con construcción pequeña de aproximadamente 100 m² con baño.
• Servicios disponibles: agua, luz e internet.
• Disponible a partir de agosto 2026.
• No tiene restricciones reportadas.
• Entorno con casas habitación de lugareños y paso vehicular hacia nuevos desarrollos habitacionales de vivienda media alta.
• Ideal para tiendas de abarrotes, farmacias con consultorio médico, laboratorio de análisis clínicos, ferreterías, servicios y restaurantes.
• Fácil y rápido acceso por conexión con calle 13 perpendicular a carretera Chichí Suárez o calle 14.`,
  },
},


/* =========================
   ­ƒÅ¡ BODEGAS
========================= */

{
  id: 25,
  title: "1000m² sobre carretera + 450m² de maniobra",
  link: "/propiedad/25",
  price: 85000,
  address: "La Costerita",
  location: "Carretera:La Costerita,Libramiento Benito Juarez",
  contrato: "Minimo 1 año",
  zona: "Corredor comercial e industrial de La Costerita",
  servicios: "Luz y agua independiente",
  flujo: "Alto flujo vehicular y de transporte de carga, ubicado en corredor industrial con presencia de bodegas, empresas y centros de distribución",
  estado: "Buen estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta,mes de desposito, fiador y documentación",
    asesorIA: {
    usosSugeridos: [],
    usosNoRecomendados: [],
    noApto: [],
    girosMismaPlaza: [],
    competenciaMismaPlaza: [],
    noDuplicarMismaPlaza: [],
    competenciaCercana: [],
    generadoresDemanda: [],
    plantaBaja: {
      ideal: [],
      apto: [],
      pocoRecomendado: [],
      noApto: [],
    },
    plantaAlta: {
      ideal: [],
      apto: [],
      pocoRecomendado: [],
      noApto: [],
    },
    perfilCliente: {
      consumidorPrincipal: [],
      ticketZona: "",
      nivelSocioeconomicoEstimado: "",
      confianza: "",
      notas: [],
    },
    validacionCampo: {
      fecha: "",
      negociosActivosConfirmados: [],
      girosMismaPlazaConfirmados: [],
      flujoObservado: "",
      horarioFuerte: [],
      estacionamientoObservado: "",
      fotosRecientes: false,
    },
    movilidad: {
      flujoVehicular: "",
      flujoPeatonal: "",
      estacionamiento: "",
      accesos: [],
      visibilidad: "",
    },
    entornoResidencial: {
      viviendasCercanas: "",
      departamentosCercanos: "",
      coloniasCercanas: [],
      observaciones: [],
    },
    entornoConsumo: {
      anclasComerciales: [],
      negociosComplementarios: [],
      flujoPorHorarios: [],
      consumoEsperado: "",
    },
    ventajas: [],
    riesgos: [],
    restriccionesOperativas: [],
    validarAntes: [],
  },
type: "bodega",
  images: [
  frentebodega5,
  bodega5luz,
  interiorbodega5,
  interior2bodega5,
  pisobodega5,
  rampabodega5,
  rampabodegaDavid,
  frentebodegarampa5,
  alturabodegaDavid,
  {
    type: "video",
    src: videobodegaexterior,
  },
  ],
  mapUrl: "https://maps.google.com/maps?q=24.740334, -107.433518&z=15&output=embed",
  details: {
    banos: "No tiene",
    frente: "20",
    fondo: "50",
    medidas: "1000 m²",
    nivel: "",

    estacionamiento: "Sí",
    ventajasRapidas: ["Conexión inmediata a carreteras y libramientos principales",
    "A un costado de gasolinera para mayor eficiencia operativa",
  "Cercanía a parques industriales y zonas de alto movimiento comercial",
   "Anden de descarga"]


  }
},

{
  id: 38,
  title: "Bodega 1000m² con oficina de 110m²",
  link: "/propiedad/38",
  price: 95000,
  address: "La Costerita",
  location: "Carretera:La Costerita,Libramiento Benito Juarez",
  contrato: "Minimo 1 año",
  zona: "Corredor comercial e industrial de La Costerita",
  servicios: "Luz y agua independiente",
  flujo: "Alto flujo vehicular y de transporte de carga, ubicado en corredor industrial con presencia de bodegas, empresas y centros de distribución",
  estado: "Buen estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentación",
  asesorIA: {
    usosSugeridos: [],
    usosNoRecomendados: [],
    noApto: [],
    girosMismaPlaza: [],
    competenciaMismaPlaza: [],
    noDuplicarMismaPlaza: [],
    competenciaCercana: [],
    generadoresDemanda: [],
    plantaBaja: {
      ideal: [],
      apto: [],
      pocoRecomendado: [],
      noApto: [],
    },
    plantaAlta: {
      ideal: [],
      apto: [],
      pocoRecomendado: [],
      noApto: [],
    },
    perfilCliente: {
      consumidorPrincipal: [],
      ticketZona: "",
      nivelSocioeconomicoEstimado: "",
      confianza: "",
      notas: [],
    },
    validacionCampo: {
      fecha: "",
      negociosActivosConfirmados: [],
      girosMismaPlazaConfirmados: [],
      flujoObservado: "",
      horarioFuerte: [],
      estacionamientoObservado: "",
      fotosRecientes: false,
    },
    movilidad: {
      flujoVehicular: "",
      flujoPeatonal: "",
      estacionamiento: "",
      accesos: [],
      visibilidad: "",
    },
    entornoResidencial: {
      viviendasCercanas: "",
      departamentosCercanos: "",
      coloniasCercanas: [],
      observaciones: [],
    },
    entornoConsumo: {
      anclasComerciales: [],
      negociosComplementarios: [],
      flujoPorHorarios: [],
      consumoEsperado: "",
    },
    ventajas: [],
    riesgos: [],
    restriccionesOperativas: [],
    validarAntes: [],
  },
  type: "bodega",
  images: [
     bodega3FotoOficina,
    bodega3Interior,
    bodega3Oficina2,
    bodega3Cuarto1,
    bodega3Cuarto1Foto2,
    bodega3Cuarto2,
    bodega3Cuarto3,
    bodega3BanosInterior,
    bodega3BanosInterior2,
    bodega3Bano,
    bodega3BanoExterior,
    bodega3Piso,
    bodega3Altura,
     bodega3Exterior,
    {
      type: "video",
      src: videoBodega3Oficina,
    },
  ],
  mapUrl: "https://maps.google.com/maps?q=24.740334, -107.433518&z=15&output=embed",
  details: {
    banos: "2 medios baños en oficina + medio baño exterior con lavamanos",
    frente: "20 m",
    fondo: "50 m",
    medidas: "Terreno 1000 m²",
    nivel: "",
    estacionamiento: "Área de maniobra cercada de 450 m²",
    ventajasRapidas: [
      "Oficina de 110 m²",
      "4 espacios disponibles",
      "Espacio 1 con acceso y 2 medios baños",
      "Espacio 2 dividido en 2 áreas más caja/recepción con vista a bodega",
      "Espacio 3 independiente",
      "Espacio 4 con closet y salida directa a bodega",
      "Andén de descarga",
      "Tinaco",
    ],

  }
},

{
  id: 39,
  title: "Bodega 100m² + 45m² de acceso en Tres Ríos",
  link: "/propiedad/39",
  price: 14000,
  address: "Colonia: Tres Ríos",
  location: "Calle: David Alfaro Siqueiros, casi esquina Blvd. Enrique Sánchez Alonso",
  contrato: "Minimo 1 año",
  zona: "Comercial y Habitacional",
  servicios: "Luz independiente, agua compartida",
  flujo: "Zona comercial con acceso rápido por Blvd. Enrique Sánchez Alonso",
  estado: "Disponible para mostrar",
  disponibilidad: "Inmediata",
  tiempoGracia: "Sí",
  requisitosRenta: "Mes de renta, mes de deposito,fiador,documentación",
  type: "bodega",
  images: [
    fachadaBodega3Rios,
    fachadaNaranjaBodega3Rios,
    interiorBodega3Rios,
    interior2Bodega3Rios,
    interior1Bodega3Rios,
    paredBodega3Rios,
    techoBodega3Rios,
    medioBanoBodega3Rios,
    fotoBano3Rios,
    { src: planoBodega3Rios, label: "Plano" },
    {
      type: "video",
      src: videoBodega3Rios,
      forceMuted: true,
    },
  ],
  lat: 24.829399,
  lng: -107.398814,
  mapUrl: "https://maps.google.com/maps?q=24.829399, -107.398814&z=15&output=embed",
  details: {
    banos: "Medio baño",
    frente: "",
    fondo: "",
    medidas: "100 m² de bodega + 45 m² de entrada. Frente: 3.30 m. Fondo: 14.90 m. Frente del fondo: 10 m. Pared lateral: 6.30 m.",
    nivel: "Planta baja",
    estacionamiento: "1 cajon",
    ventajasRapidas: [
      "Menores tiempos de traslado para entregas y recolecciones.",
      "Acceso rápido a las principales avenidas",
      "Ideal para logística de última milla",
      "Mayor cercanía con clientes y proveedores"
    ],

  }
},

{
  id: 107,
  title: "Bodega de 288 m² con oficina de 24 m², agua y mantenimiento incluido",
  link: "/propiedad/107",
  price: 15000,
  address: "El 10",
  location: "Carretera hacia El Dorado, El 10, 80393 Culiacán Rosales, Sin.",
  contrato: "Minimo 1 año",
  zona: "Corredor logistico e industrial El Diez",
  servicios: "Luz independiente trifasica",
  flujo: "Acceso rapido hacia carretera Culiacan-Mazatlan, El Dorado y corredores industriales cercanos",
  estado: "Buen estado",
  disponibilidad: "Inmediata",
  tiempoGracia: "Si",
  requisitosRenta: "Mes de renta, mes de deposito, fiador y documentacion",
  asesorIA: {
    usosSugeridos: [
      "bodega",
      "almacen",
      "logistica",
      "distribucion",
      "taller ligero",
      "paqueteria",
      "insumos agricolas",
    ],
    usosNoRecomendados: [
      "giros que dependan de alto flujo peatonal",
      "restaurantes de consumo inmediato",
      "retail de aparador",
    ],
    noApto: [
      "negocios que requieran ubicacion dentro de zona residencial",
      "giros nocturnos",
    ],
    girosMismaPlaza: [],
    competenciaMismaPlaza: [],
    noDuplicarMismaPlaza: [],
    competenciaCercana: [],
    generadoresDemanda: [
      "carretera Culiacan-Mazatlan",
      "zona Piggy Back",
      "La Primavera",
      "El Trebol",
      "corredor El Diez",
    ],
    plantaBaja: {
      ideal: ["bodega", "almacen", "centro de distribucion", "taller ligero", "paqueteria"],
      apto: ["oficina operativa", "venta mayorista con almacen", "resguardo de inventario"],
      pocoRecomendado: ["showroom muy dependiente de aparador", "consultorio"],
      noApto: ["restaurante", "bar", "local de moda"],
    },
    plantaAlta: {
      ideal: [],
      apto: [],
      pocoRecomendado: [],
      noApto: [],
    },
    perfilCliente: {
      consumidorPrincipal: ["empresas de reparto", "proveedores", "contratistas", "operadores logisticos"],
      ticketZona: "Medio a alto por giro industrial",
      nivelSocioeconomicoEstimado: "Operativo e industrial",
      confianza: "Media",
      notas: [
        "La ubicacion favorece operaciones con camionetas, reparto y almacenamiento.",
        "Conviene confirmar medidas, energia disponible y maniobras antes de publicar precio final.",
      ],
    },
    validacionCampo: {
      fecha: "",
      negociosActivosConfirmados: [],
      girosMismaPlazaConfirmados: [],
      flujoObservado: "Vehicular y de carga",
      horarioFuerte: ["mañana", "tarde"],
      estacionamientoObservado: "Area de maniobra y acceso vehicular dentro del conjunto",
      fotosRecientes: true,
    },
    movilidad: {
      flujoVehicular: "Conectividad carretera cercana",
      flujoPeatonal: "Bajo",
      estacionamiento: "Area de maniobra y acceso vehicular",
      accesos: ["Carretera hacia El Dorado", "carretera Culiacan-Mazatlan"],
      visibilidad: "Acceso por corredor de bodegas",
    },
    entornoResidencial: {
      viviendasCercanas: "",
      departamentosCercanos: "",
      coloniasCercanas: ["El 10", "La Primavera"],
      observaciones: ["Zona con vocacion de almacenamiento, operacion y distribucion."],
    },
    entornoConsumo: {
      anclasComerciales: ["zona Piggy Back", "carretera Culiacan-Mazatlan", "La Primavera"],
      negociosComplementarios: ["bodegas", "transportistas", "proveedores", "talleres"],
      flujoPorHorarios: ["movimiento operativo durante el dia"],
      consumoEsperado: "Demanda empresarial y logistica",
    },
    ventajas: [
      "Cerca de:\nCarretera Culiacan-Mazatlan (185 m aprox.)\nPiggy Back (3.5 km aprox.)\nLa Primavera (3.2 km aprox.)\nTrebol de acceso carretero (900 m aprox.)",
      "Agua incluida",
    ],
    riesgos: [
      "Confirmar altura libre y maniobras requeridas por el giro.",
      "Validar si el giro requiere permisos especiales.",
    ],
    restriccionesOperativas: [],
    validarAntes: ["altura libre", "maniobras", "capacidad electrica final"],
  },
  type: "bodega",
  ribbon: "BODEGA",
  images: [
    frenteBodegaDiez,
    calleBodegaDiez,
    puertaBodegaDiez,
    interiorBodegaDiez,
    pisoBodegaDiez,
    fachadaOficinaDiez,
    recepcionDiez,
    recepcionDiez2,
    privadoOficinaDiez,
    banoBodegaDiez,
  ],
  lat: 24.732265885438856,
  lng: -107.45885476398988,
  mapUrl: "https://maps.google.com/maps?q=24.732265885438856,-107.45885476398988&z=15&output=embed",
  details: {
    banos: "Baño en area de oficina",
    frente: "",
    fondo: "",
    medidas: "Frente 12 m x fondo 20 m.\n288 m².\nOficina 6 m x 4 m, total 24 m².",
    nivel: "Planta baja",
    estacionamiento: "Area de maniobra y acceso vehicular dentro del conjunto",
    ventajasRapidas: [
      "Cerca de:\nCarretera Culiacan-Mazatlan (185 m aprox.)\nPiggy Back (3.5 km aprox.)\nLa Primavera (3.2 km aprox.)\nTrebol de acceso carretero (900 m aprox.)",
      "Agua incluida.",
      "Mantenimiento incluido.",
      "Zona privada con velador.",
      "Bodega con oficina, recepcion, Privado y baño.",
      "Acceso vehicular y area de maniobra para operacion diaria.",
    ],
  }
},


]


